<script setup>
import { ref, onMounted } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiHomeSearch, mdiWhatsapp, mdiCashPlus,
    mdiCradle, mdiPuzzleRemove, mdiTownHall, mdiCross, mdiPill, mdiMedicalBag, mdiGymnastics, mdiWater, mdiCheckDecagram, mdiContentSave, mdiAccountSupervisor,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail, mdiInformationOutline, mdiPrinter, mdiFileDocumentMultipleOutline,
    mdiCardAccountDetails, mdiGenderMaleFemale, mdiCellphone, mdiEmail, mdiClockTimeFive
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';


import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    //apoderado: Object,
    typeDocuments: Object,
    distritos: Object,
    colegios: Object,
    parentescos: Object,
    religions: Object,
    estadoCiviles: Object,
    cursos: Object,
    chartCompetencias: Object,
    levels: Object,
    classrooms: Object,
    teoricClassrooms: Object,
    events: Array,
    user: Object,
    user_modif: Object,
    user_modif_status: Object,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    anioEscolar: String,
    back_link: String,
    closeB1: Boolean,
    closeB2: Boolean,
    closeB3: Boolean,
    closeB4: Boolean,
    existParcial2B1: Boolean,
    existParcial2B2: Boolean,
    existParcial2B3: Boolean,
    existParcial2B4: Boolean,
    debugInertia: Boolean,
    stories: Array,
    apoderados: Array,
    sedes: Object
});


/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const anioSearch = ref(null)

const chartCalifications = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
onMounted(() => {
    listarChartCalification()
    langs()
    //listarAdmisionPuntaje()
});

const listarChartCalification = (ref_ciclo = '') => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let id_student = props.object ? props.object.id : 0
    let url = '/calification/grafica' + '?id=' + id_student + '&ref_ciclo=' + ref_ciclo;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartCalifications.value = respuesta;// El return directo del array trae otros datos que generan error para el chart
        console.log(respuesta);
    }).catch(function (error) {
        console.log(error);
    });
}

const pruebaevents = [
    { id: 1, start: '2023-04-19 12:00', end: '2023-04-19 13:00', title: 'Más trabajo, está bien 1', content: 'es mejor que halla más trabajo 1', deletable: 1 },
    { id: 2, start: '2023-04-20 12:00', end: '2023-04-23 17:00', title: 'Más trabajo, está bien 2', content: 'es mejor que halla más trabajo 2', split: 1 },
    { id: 3, start: '2023-04-20 12:00', end: '2023-04-21 14:00', title: 'Más trabajo, está bien 3', content: 'es mejor que halla más trabajo 3', allday: 1 },
    { id: 4, start: '2023-04-17 12:00', end: '2023-04-18 13:00', title: 'Más trabajo, está bien 4', content: 'es mejor que halla más trabajo 4', resizable: 1 }
]

const pruebanotas = {
    "files": [
        { "id": 1, "course": "Geometría", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('student')
const modulo = ref('Estudiante')
const modulos = ref('Estudiantes')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)
if (action.value == 'view_apoderado') {
    tab.value = 1
}

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Persona
    apellidos: props.object ? props.object.person.apellidos : '',
    nombres: props.object ? props.object.person.nombres : '',
    id_type_document: props.object ? props.object.person.id_type_document : 1,// 1 DNI
    num_doc: props.object ? props.object.person.num_doc : '',
    domicilio: props.object ? props.object.person.domicilio : '',
    sexo: props.object ? props.object.person.sexo : 0,
    id_distrito_domicilio: props.object ? (props.object.person.id_distrito_domicilio ?? null) : null,// Sedeje documento que es posible hacer esto
    referencia: props.object ? props.object.person.referencia : '',
    fecha_nacimiento: props.object ? props.object.person.fecha_nacimiento : '',
    id_distrito_nacimiento: props.object ? props.object.person.id_distrito_nacimiento : null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: props.object ? props.object.person.telefono : '',
    celular: props.object ? props.object.person.celular : '',
    email: props.object ? props.object.person.email : '',

    // Estudiante
    id_colegio_procedencia: props.object ? props.object.id_colegio_procedencia : null,
    id_distrito_colegio: props.object ? props.object.id_distrito_colegio : null,
    id_religion: props.object ? props.object.id_religion : null,
    exonerado_religion: props.object ? props.object.exonerado_religion : 0,
    alergia: props.object ? props.object.alergia : '',
    enfermedad: props.object ? props.object.enfermedad : '',
    apto_edu_fisica: props.object ? props.object.apto_edu_fisica : 1,// Si está apto por defecto
    tamisaje_hemoglobina: props.object ? props.object.tamisaje_hemoglobina : 0,
    obs_aprendizaje: props.object ? props.object.obs_aprendizaje : '',
    obs_seguro_salud: props.object ? props.object.obs_seguro_salud : '',
    obs_situacion_familiar: props.object ? props.object.obs_situacion_familiar : '',
    obs_datos_vivienda: props.object ? props.object.obs_datos_vivienda : '',
    id_estado_civil_padres: props.object ? props.object.id_estado_civil_padres : null,
    obs_estado_padres: props.object ? props.object.obs_estado_padres : '',
    fecha_matricula: props.object ? props.object.fecha_matricula : '',
    type: props.object ? props.object.type : 0,// Antigui
    //status_financiero: props.object ? props.object.status_financiero : 0
    vacuna_pentavalente: props.object ? props.object.vacuna_pentavalente : 0,
    vacuna_odpt: props.object ? props.object.vacuna_odpt : 0,
    obs_otros: props.object ? props.object.obs_otros : '',
    aprendizaje_terapia: props.object ? props.object.aprendizaje_terapia : 0,
    id_level: props.object ? props.object.id_level : null,
    id_classroom: props.object ? props.object.id_classroom : null,
    id_classroom_ugel: props.object ? props.object.id_classroom_ugel : null,
    id_classroom_matricula: props.object ? props.object.id_classroom_matricula : null,
    pension_preferencial: props.object ? props.object.pension_preferencial : 0,
    becado: props.object ? props.object.becado : 0,
    note: props.object ? props.object.note : '',
    financial_note: props.object ? props.object.financial_note : '',
    ref_ugel: props.object ? props.object.ref_ugel : '',
    fecha_retiro: props.object ? props.object.fecha_retiro : '',
    fecha_reingreso: props.object ? props.object.fecha_reingreso : '',
    fecha_compromiso_pago: props.object ? props.object.fecha_compromiso_pago : '',
    sede_origen: props.object ? props.object.sede_origen : '',
    change_login: 0,

    // Crear ordne de pago
    crear_orden_pago: 0,
    orderAnio: props.anioEscolar,
    order03: false,
    order04: false,
    order05: false,
    order06: false,
    order07: false,
    order08: false,
    order09: false,
    order10: false,
    order11: false,
    order12: false,
    order13: false,
});

const formApoderado = useForm({
    id_student: props.object ? props.object.id : 0,
    id: 0,
    // Persona
    id_person: 0,
    apellidos: '',
    nombres: '',
    id_type_document: 1,// 1 DNI
    num_doc: '',
    domicilio: '',
    sexo: 0,
    id_distrito_domicilio: null,// Sedeje documento que es posible hacer esto
    referencia: '',
    fecha_nacimiento: '',
    id_distrito_nacimiento: null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: '',
    celular: '',
    email: '',

    // Contact
    id_parentesco: null,
    ocupation: null,
    trabajo: null,
    horario_laboral: '',
    telefono_trabajo: '',
    celular_trabajo: '',
    note: null,// Si está apto por defecto
    type: null,
    change_login_apoderado: 0
});

const typeContacts = ref([{'id': 0, 'label': 'Otro'}, {'id': 1, 'label': 'Responsable de pagos'}])

//console.log(props.typeDocuments)

const apoderado = ref(null)

const actualizarContacto = (object = null) => {
    apoderado.value =  object
    //console.log(object)
    formApoderado.id = apoderado.value.id
    formApoderado.apellidos = apoderado.value.person.apellidos
    formApoderado.nombres = apoderado.value.person.nombres,
    formApoderado.id_type_document = apoderado.value.person.id_type_document,// 1 DNI
    formApoderado.num_doc = apoderado.value.person.num_doc,
    formApoderado.domicilio = apoderado.value.person.domicilio,
    formApoderado.sexo = apoderado.value.person.sexo,
    formApoderado.id_distrito_domicilio = apoderado.value.person.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
    formApoderado.referencia = apoderado.value.person.referencia,
    formApoderado.fecha_nacimiento = apoderado.value.person.fecha_nacimiento,
    formApoderado.id_distrito_nacimiento = apoderado.value.person.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
    formApoderado.telefono = apoderado.value.person.telefono,
    formApoderado.celular = apoderado.value.person.celular,
    formApoderado.email = apoderado.value.person.email,

    // Contact
    formApoderado.id_parentesco = apoderado.value.id_parentesco,
    formApoderado.ocupation = apoderado.value.ocupation,
    formApoderado.trabajo = apoderado.value.trabajo,
    formApoderado.horario_laboral = apoderado.value.horario_laboral,
    formApoderado.telefono_trabajo = apoderado.value.telefono_trabajo,
    formApoderado.celular_trabajo = apoderado.value.celular_trabajo,
    formApoderado.note = apoderado.value.note,// Si está apto por defecto
    formApoderado.type = apoderado.value.type == 1 ? apoderado.value.type : null
    //formApoderado.change_login_apoderado
}

const getContactForDoc = (doc = '') => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let id_student = props.object ? props.object.id : 0
    let url = '/student/getContactForDoc' + '?documento=' + doc;
    axios.get(url).then((response) => {
        let respuesta = response.data;
        //apoderado.value = respuesta;
        crearContactoAPartirdeOtro(respuesta.apoderado, respuesta.isotherperson)
        console.log(respuesta);
    }).catch((error) => {
        console.log(error.response.data);
    });
}

const existeContacto = ref(false)

const crearContactoAPartirdeOtro = (object = null, isotherperson = 0) => {
    apoderado.value =  object
    //console.log(object)
    if (apoderado.value.id > 0) {
        existeContacto.value = true
        if (isotherperson > 0) {
            // El otra persona y se toma sus datos
            formApoderado.id_person = apoderado.value.id
            formApoderado.apellidos = apoderado.value.apellidos
            formApoderado.nombres = apoderado.value.nombres,
            formApoderado.id_type_document = apoderado.value.id_type_document,// 1 DNI
            formApoderado.num_doc = apoderado.value.num_doc,
            formApoderado.domicilio = apoderado.value.domicilio,
            formApoderado.sexo = apoderado.value.sexo,
            formApoderado.id_distrito_domicilio = apoderado.value.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
            formApoderado.referencia = apoderado.value.referencia,
            formApoderado.fecha_nacimiento = apoderado.value.fecha_nacimiento,
            formApoderado.id_distrito_nacimiento = apoderado.value.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
            formApoderado.telefono = apoderado.value.telefono,
            formApoderado.celular = apoderado.value.celular,
            formApoderado.email = apoderado.value.email

            console.log('Contacto nuevo desde otra persona')
        } else {
            console.log(apoderado.value.id_person);
            formApoderado.id_person = apoderado.value.id_person
            formApoderado.apellidos = apoderado.value.person.apellidos
            formApoderado.nombres = apoderado.value.person.nombres,
            formApoderado.id_type_document = apoderado.value.person.id_type_document,// 1 DNI
            formApoderado.num_doc = apoderado.value.person.num_doc,
            formApoderado.domicilio = apoderado.value.person.domicilio,
            formApoderado.sexo = apoderado.value.person.sexo,
            formApoderado.id_distrito_domicilio = apoderado.value.person.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
            formApoderado.referencia = apoderado.value.person.referencia,
            formApoderado.fecha_nacimiento = apoderado.value.person.fecha_nacimiento,
            formApoderado.id_distrito_nacimiento = apoderado.value.person.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
            formApoderado.telefono = apoderado.value.person.telefono,
            formApoderado.celular = apoderado.value.person.celular,
            formApoderado.email = apoderado.value.person.email,

            // Contact
            formApoderado.id_parentesco = apoderado.value.id_parentesco,
            formApoderado.ocupation = apoderado.value.ocupation,
            formApoderado.trabajo = apoderado.value.trabajo,
            formApoderado.horario_laboral = apoderado.value.horario_laboral,
            formApoderado.telefono_trabajo = apoderado.value.telefono_trabajo,
            formApoderado.celular_trabajo = apoderado.value.celular_trabajo,
            formApoderado.note = apoderado.value.note,// Si está apto por defecto
            formApoderado.type = apoderado.value.type == 1 ? apoderado.value.type : null
            //formApoderado.change_login_apoderado
            console.log('Contacto desde otro contacto')
        }
    } else {

        console.log('Contacto nuevo')
    }
    
}

const clean = (origen='') => {
    if (origen == 'apoderado') {
        existeContacto.value = false
        apoderado.value = null
        action.value = 'view_apoderado'
    }
    if (origen == 'student') {
        action.value = 'view'
    }
    
}

/**
 * 
 * LRR 
 * Incializar valorres
 */

const optionsGenero = [
    { id: 0, label: 'Femenino' },
    { id: 1, label: 'Masculino' },
]
const optionsTamizaje = [
    { id: 0, label: 'Pendiente con compromiso' },
    { id: 1, label: 'Realizado y entregado' },
]
/*
const optionsVivienda = [
    {id: 0, label: 'Casa propia'},
    {id: 1, label: 'Casa alquilada'},
    {id: 2, label: 'Casa de otros familiares'},
    {id: 3, label: 'Casa alquilada'},
    {id: 9, label: 'Otro :'},
]
*/

// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// LRR un simple array para usar sólo option del componente input

// Seguro de salud
const optionsSeguroSalud = [
    'Particular',
    'ESSALUD',
    'SIS',
    'No tiene',
]
const selectSeguroSalud = ref('')
const textSeguroSalud = ref('')
if (props.object && props.object.obs_datos_SeguroSalud) {
    let arraySeguroSalud = props.object.obs_datos_SeguroSalud.split(' : ')
    selectSeguroSalud.value = arraySeguroSalud[0]
    if (arraySeguroSalud[1]) textSeguroSalud.value = arraySeguroSalud[1]
} else {
    selectSeguroSalud.value = optionsSeguroSalud[3]// <-- Selección por defecto al crear
}

// Situación familiar
const optionsSituacionFamiliar = [
    'Sus 2 padres y hermanos',
    'Sólo con su mamá',
    'Sólo con su papá',
    'Con otros familiares',
]
const selectSituacionFamiliar = ref('')
const textSituacionFamiliar = ref('')
if (props.object && props.object.obs_situacion_familiar) {
    let arraySituacionFamiliar = props.object.obs_situacion_familiar.split(' : ')
    selectSituacionFamiliar.value = arraySituacionFamiliar[0]
    if (arraySituacionFamiliar[1]) textSituacionFamiliar.value = arraySituacionFamiliar[1]
}

// Vivienda
const optionsVivienda = [
    'Casa propia',
    'Casa alquilada',
    'Casa de otros familiares',
    'Casa alquilada',
    'Otro'
]

const selectVivienda = ref('')
const textVivienda = ref('')
if (props.object && props.object.obs_datos_vivienda) {
    let arrayVivienda = props.object.obs_datos_vivienda.split(' : ')
    selectVivienda.value = arrayVivienda[0]
    if (arrayVivienda[1]) textVivienda.value = arrayVivienda[1]
    /* if (arrayVivienda.length > 1) {
        selectVivienda.value = arrayVivienda[0]
        textVivienda.value = arrayVivienda[1]
    } else {
        let result = props.object.obs_datos_vivienda.replace(' : ', '')
        optionsVivienda.includes(result) ? selectVivienda.value = result : textVivienda.value = result
    } */
} else {
    selectSeguroSalud.value = optionsSeguroSalud[4]// <-- Selección por defecto al crear
}


    // Crear o actualizar
    const submit = () => {
        if (action.value == 'create') {
            form.post(route(rutaPrefijo.value + '-registrar'), {
                //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
                onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            });
        } else {
            form.put(route(rutaPrefijo.value + '-actualizar'), {
                onFinish: () => {
                    form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje, change_login')
                    clean('student')
                },
                onError: () => window.Toast.error(errors.create)
            });
        }

    };

    const submitApoderado = () => {
        if (action.value == 'create_apoderado') {
            formApoderado.post(route('apoderado-registrar'), {
                //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
                onSuccess: () => {
                    formApoderado.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'id_parentesco')
                    clean('apoderado')
                },
                //onError: () => window.Toast.error(errors.create)
            });
        } else {
            formApoderado.put(route('apoderado-actualizar'), {
                onFinish: () => {
                    formApoderado.reset('apellidos, nombres, email, telefono, celular, id_parentesco, change_login_apoderado')
                    clean('apoderado')
                    
                },
                onError: () => window.Toast.error(errors.edit)
            });
        }

    };

    const showNotas = ref([])

    //const cancel = () => {
    //if (rutaPrefijo.value=='student') {
    //form.obs_aprendizaje = '';
    //}
    //}

    const formatDate = (date) => {
        //var now = new Date().toLocaleDateString()
        var date = new Date(date)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        return result
    }

    //console.log(props.object)
    const formatDateTime = (datetime) => {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

    // Dividir secciones con tabs
    let myRadios = document.getElementsByName('tabs2');
    let setCheck;
    let x = 0;
    for (x = 0; x < myRadios.length; x++) {
        myRadios[x].onclick = function () {
            if (setCheck != this) {
                setCheck = this;
            } else {
                this.checked = false;
                setCheck = null;
            }
        };
    }

    /**
     * Section Calification
     */
    const tabCalif = ref(-1)
    const showLog = ref(false);
    const formCalification = useForm({
        id_student: props.object ? props.object.id : null,// <-- Al crear estudiante noe xiste object
        ref_ciclo: '',
        //id_course: 0,
        asistencia: '8',
        participacion: '8',
        tarea: '8',
        conducta: '8',
        examen_parcial: '8',
        examen_parcial2: null,
        examen_final: '8',
        promedio: '8',
        //promedio_number: 0, creado en el controller
        status: 0

    });

    //const doubleCLickBlock = ref(0)
    const iniciarCalification = (ref_ciclo) => {
        /* for (let i = 0; i < props.students; i++) {
            pagesList.push(i);
        } */
        //doubleCLickBlock.value = 1

        // Determinar si existe Parcial 2 y asignar 8
        let existParcial2 = null
        if (tabCalif.value == 0 && props.existParcial2B1) {
            existParcial2 = true
        } else if (tabCalif.value == 1 && props.existParcial2B2) {
            existParcial2 = true
        } else if (tabCalif.value == 2 && props.existParcial2B3) {
            existParcial2 = true
        } else if (tabCalif.value == 3 && props.existParcial2B4) {
            existParcial2 = true
        } else {
            existParcial2 = false
        }

        //console.log(existParcial2)

        const newArr = [];
        const arr = props.cursos
        arr.forEach((course) => {
            newArr.push({
                id_student: formCalification.id_student,
                id_course: course.id,
                asistencia: formCalification.asistencia,
                participacion: formCalification.participacion,
                tarea: formCalification.tarea,
                conducta: formCalification.conducta,
                examen_parcial: formCalification.examen_parcial,
                //examen_parcial2: formCalification.examen_parcial2,
                examen_parcial2: (existParcial2 ? '8' : null),// <-- Esto es opcional pero se debe registrar si está activo
                examen_final: formCalification.examen_final,
                promedio: formCalification.promedio,
                status: 0
            });
        });
        let ruta = 'calification-registrar'
        if (newArr.length) {
            axios.post(route(ruta), {
                'origin': 'student',
                'ref_ciclo': ref_ciclo,
                'arrayData': newArr,

            }).then((response) => {
                let respuesta = response.data;
                listarCalification(ref_ciclo)
                if (respuesta.error) {
                    showAlert(respuesta.message, 'danger', 16)
                } else {
                    showAlert('Se inició las calificaciones del ' + ref_ciclo, 'success', 3)
                }
                //console.log('Registro actualizado');
                console.log(newArr)
                console.log(respuesta.message)
                //doubleCLickBlock.value = 0
            }).catch((error) => {
                console.log(error);
            });

        }
        //return newArr;
    }

    const feedbackLabel = ref('');
    const feedbackDesc = ref('');
    const feedbackShow = ref(false);
    let countAction = 0
    let countActionOk = 0
    let guardarTodo = 0
    const updateCalification = (id, action, data = []) => {
        let ruta = 'calification-' + action
        if (id > 0) {

            if (action == 'actualizar') {
                //countAction++
                //alertIndex.value = 
                axios.put(route(ruta), {
                    'id': id,
                    'asistencia': data['asistencia'],
                    'participacion': data['participacion'],
                    'tarea': data['tarea'],
                    'conducta': data['conducta'],
                    'examen_parcial': data['examen_parcial'],
                    'examen_parcial2': data['examen_parcial2'],
                    'examen_final': data['examen_final'],
                    'promedio': data['promedio'],
                    'promedio_text': data['promedio_text']
                }).then((response) => {
                    countAction++
                    countActionOk++

                    if (!guardarTodo) {
                        showAlert(countAction + ' registro actualizado', 'success')
                        countAction = 0
                        countActionOk = 0
                    } else {
                        if (countAction == 1) {
                            showAlert('Validando, espere por favor ...', 'warning', 3)
                        }

                        if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                            showAlert(countActionOk + ' registros actualizados', 'success', 3)
                            countAction = 0
                            countActionOk = 0
                            guardarTodo = 0
                        }
                    }

                    //console.log(countAction+' registro actualizado');
                }).catch((error) => {
                    console.log(error);
                    errors.value = 1
                    countAction++

                    showAlert(countAction + ' registro con error', 'danger', 10)
                    if (!guardarTodo) {
                        countAction = 0
                    } else {
                        if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                            countAction = 0
                            countActionOk = 0
                            guardarTodo = 0
                        }
                    }
                    //console.log(countAction+' registro con error');
                });

                /* Inertia.put(route(ruta, {
                    'id' : id,
                    'asistencia': data['asistencia'],
                    'participacion': data['participacion'],
                    'tarea': data['tarea'],
                    'conducta': data['conducta'],
                    'examen_parcial': data['examen_parcial'],
                    'examen_parcial2': data['examen_parcial2'],
                    'examen_final': data['examen_final'],
                    'promedio': data['promedio'],
                    onFinish: () => { 
                            put.completed = true
                            feedbackLabel.value = 'User sucessfully Added!';
                            feedbackDesc.value = usePage().props.value.flash.notification;
                            feedbackShow.value = true;
                            console.log('Actualizado')
                        }
                    }
                )) */
            } else {
                axios.put(route(ruta), {
                    'id': id,
                }).then(function (response) {
                    showAlert('Estado actualizado', 'success')

                    // Lista dependiendo en que tab está
                    if (tabCalif.value == 0) {
                        console.log('Primer bimestre')
                        listarCalification(props.anioEscolar + 'B1')
                    } else if (tabCalif.value == 1) {
                        console.log('Segundo bimestre')
                        listarCalification(props.anioEscolar + 'B2')
                    } else if (tabCalif.value == 2) {
                        console.log('Tercer bimestre')
                        listarCalification(props.anioEscolar + 'B3')
                    } else if (tabCalif.value == 3) {
                        console.log('Cuarto bimestre')
                        listarCalification(props.anioEscolar + 'B4')
                    }

                    console.log('Año escolar: ' + props.anioEscolar);
                }).catch(function (error) {
                    console.log(error);
                });
                //listarCalification()
                //Inertia.reload({ only: ['message']})
                console.log('Año escolar: ' + props.anioEscolar);
            }

        }

        //isAlertActive.value = true

        //console.log(arrayDiario.value)
    }
    const arrayCalifications = ref([])
    const listarCalification = (ref_ciclo) => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        let url = '/calification/student' + '?ref_ciclo=' + ref_ciclo + '&id_student=' + props.object.id;
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayCalifications.value = respuesta.datalist;
            if (respuesta.error) {
                showAlert(respuesta.message, 'danger', 16)
            }
            //console.log(arrayCalifications.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const number2nota = (notaN) => {
        let nota = parseFloat(notaN).toFixed(2);
        let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
        //console.log(nota)
        return result
    }

    //const isActionMassive = ref(false)
    const updateArrayCalifications = (bimestre = '') => {
        //isActionMassive.value = true
        guardarTodo = 1
        let buttons = document.getElementsByName('buttonssave' + bimestre);
        //let count = 0
        //let lastIt = buttons.length - 1
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].click();
        }
    }

    const haveEAP = ref(0)
    const arrayAdmisionPuntaje = ref([])
    const listarAdmisionPuntaje = () => {
        let url = '/admisionpuntaje/student?id_student=' + props.object.id + '&anioSearch=' + anioSearch.value;
        axios.get(url).then(function (response) {
            var respuesta = response.data;
            arrayAdmisionPuntaje.value = respuesta.admisionpuntajes;
            haveEAP.value = respuesta.haveEAP;
            //console.log(filesForLevel.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    /**
     * Section Alert
     */

    const isAlertActive = ref(false)
    const isAlertDangerActive = ref(false)
    const messageAlert = ref('')
    /* const error = ref(0)
    const errors = ref([]) */
    const colorAlert = ref('success')
    const errormsg = ref(null)
    const errors = ref(0)
    const alertIndex = ref(0)

    const showAlert = (message, color, time = 1) => {

        messageAlert.value = message
        colorAlert.value = color

        isAlertActive.value = true

        /* if (color == 'danger') {
            isAlertDangerActive.value = true
        } else {
            isAlertActive.value = true
        } */
        setTimeout(() => {
            isAlertActive.value = false
            /* if (color == 'danger') {
                isAlertDangerActive.value = false
            } else {
                isAlertActive.value = false
            } */
            errormsg.value = ref(null)
            errors.value = ref(0)
            alertIndex.value = ref(0)
            //isActionMassive.value = false
        }, time * 1000)// LRR bind(this)


    }

    const backLink = ref(props.back_link ? '/#' + props.back_link : '')

    // Traducir textos
    const trans = ref() // <-- Transformar objecto reactivo
    const langs = () => {
        let url = '/lang/traducir?id_level=' + (props.object ? (props.object.level ? props.object.level.id : 0) : 0);
        axios.get(url).then((response) => {
            let respuesta = response.data;
            console.log(respuesta);
            if (respuesta) {
                trans.value = respuesta;
            }
        }).catch((error) => {
            console.log(error);

        });
    }

    /**
     * Procesar archivos adjuntos
     */
    const arrayDocumentos = ref([]);
    const arrayDocumentosCol = ref([]);
    const listarDocumentos = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/document/file_document_student?src_object_id='+props.object.id;
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayDocumentos.value = respuesta.datalist;
            arrayDocumentosCol.value = respuesta.columnas;
            console.log(arrayDocumentos.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const inputFileName = ref('')
    const inputFileDesc = ref('')
    const inputFilePos = ref(1)
    const showInputFile = ref(false)
    const fileDocument = ref(null)
    const fileSize = ref(0)
    const changeFile = (type) => {
        //fileSubida.value = this.$refs.fileSubida.files[0];
        let file = null;
        if (type == 'file_document_student') {
            file = fileDocument.value.files[0];
        }

        //console.log(file);
        console.log(file.size);

        // FIX error Failed to set the 'value' property on 'HTMLInputElement'
        if (file) {
            fileSize.value = file.size
            if (file.name.includes('.jpg') || file.name.includes('.png')) {
                console.log('Es imagen')
            } else {
                console.log('No es imagen jpg o png')
            }
        }

    }

    const uploadFile = (type, origin_id = 0) => {
        let data = new FormData()
        let file = null;
        if (type == 'file_document_student') {
            file = fileDocument.value.files[0];
            origin_id = props.object.id
        }
        data.append('file', file)
        data.append('origin_type', type)
        
        // Se puede agregar otro origin id si fuera necesario
        data.append('origin_id', origin_id)
        
        data.append('name', inputFileName.value)
        data.append('description', inputFileDesc.value)
        data.append('position', inputFilePos.value)
        console.log(file)
        axios.post('/file/upload', data)
            .then(response => {

                if (response.data.error) {
                    showAlert(response.data.message, 'danger', 5)
                    if (type == 'file_document_student') {
                        errorMessage.value == response.data.message
                    }
                } else if (response.data.success) {
                    showAlert(response.data.message, 'success', 2)
                    listarDocumentos()
                    cleanInputFile()
                    
                }
                console.log(response.data)
            })
            .catch(error => {
                console.log(error)
            })

    }

    const cleanInputFile = () => {
        inputFileName.value = ''
        inputFileDesc.value = ''
        inputFilePos.value = 1
        fileDocument.value = null
        fileSize.value = 0
    }

</script>

<template>
    <Head :title="object ? object.person.apellidos + ' ' + object.person.nombres : 'Nuevo estudiante'" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="flex justify-between items-center">
                <div>
                    <div v-if="action != 'create'" class="flex flex-wrap tab-m">
                        <button @click="(tab = 0), (action = 'view')"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Estudiante</span>
                        </button>
                        <button @click="(tab = 1), (action = 'view_apoderado')"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Contacto/Apoderado</span>
                        </button>
                        <button @click="(tab = 2)"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 2 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Calificaciones</span>
                        </button>

                        <button @click="(tab = 3)"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 3 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Agenda</span>
                        </button>
                        <button @click="(tab = 4)"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 4 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Historia</span>
                        </button>
                        <button @click="(tab = 5, listarDocumentos())"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 5 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Documentos</span>
                        </button>
                        <!-- <button @click="(tab=1)" class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Informe de progreso</span>
                        </button>
                        <button @click="(tab=2)" class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==2 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Portafolio</span>
                        </button>
                        <button @click="(tab=3)" class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==3 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Anecdotario</span>
                        </button>
                        <button @click="(tab=4)" class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==4 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Carpeta de recuperación</span>
                        </button> -->

                        <!-- Volver al listado -->
                        <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                    icon-size="20" small label="Refresh"
                                    :inertiahref="route('collaborator-classroom', {'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link})"/>
                        -->

                        <button v-if="action == 'view_apoderado' && canWrite && tab == 1" @click="action = 'create_apoderado'"
                            class="lg:hidden relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0 bg-blue-600 border-blue-600">
                            <span class="text-sm lg:text-lg text-white leading-tigh font-medium"> [+] Crear Contacto</span>
                        </button>
                        
                    </div>
                    <div v-else>
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Nuevo estudiante</span>
                    </div>
                </div>
                <div v-if="action == 'view_apoderado' && canWrite && tab == 1" class="hidden lg:flex items-center h-full">
                        <BaseButton small color="info" :icon="mdiPlusCircle" @click="action = 'create_apoderado'"
                                    label=" Crear Contacto" class="mb-0" />
                    
                </div>
            </div>

            <BreezeValidationErrors class="mb-4 mt-4" />

            <!-- In basebutton: @click="route('dashboard')"-->

            <!--<Link :href="route('student-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>

                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->

        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <template v-if="(tab == 0)">
                    <template v-if="action == 'view' && object">
                        <div class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-4">
                            <div class="md:col-span-4 bg-white rounded-lg shadow-lg p-6 h-full my-auto">
                                <div class="grid grid-1 md:grid-cols-4 gap-4 h-full">
                                    <div class="col-span-1 h-auto my-auto">
                                        <img class="max-w-full h-44 lg:h-full rounded-lg border-2 border-gray-600 shadow-xl"
                                            :src="object.person.sexo ? '/img/student/boy.png' : '/img/student/girl.png'">
                                    </div>
                                    <div class="col-span-1 md:col-span-3 h-auto my-auto">
                                        <div class="flex items-center h-full justify-start">
                                            <div>
                                                <span class="text-lg font-bold">{{
                                                    object.person.apellidos + ' ' + object.person.nombres
                                                }}</span><br>
                                                <span class="font-bold mr-2">DNI : </span>{{ object.person.num_doc }}
                                                <br>
                                                <span class="font-bold mr-2">Género : </span>{{ object.person.sexo ?
                                                    'Masculino' :
                                                    'Femenino'
                                                }}<br>
                                                <span class="font-bold mr-2">Teléfono : </span> {{
                                                    object.person.telefono
                                                }}, celular : {{ object.person.celular }}<br>
                                                <span class="font-bold mr-2">Email : </span> {{ object.person.email }}<br>
                                                <span class="font-bold mr-2">Dirección : </span> {{
                                                    object.person.domicilio
                                                }}, distrito : {{
                                                    object.person.id_distrito_domicilio ? distritos.find(item => item.id ===
                                                        object.person.id_distrito_domicilio).label : ''
                                                }}<br>
                                                <span class="font-bold mr-2">Login : </span>
                                                {{ user.email }}<br>
                                                <span class="font-bold mr-2">User : </span>
                                                {{ user.user }} (clave default = DNI)
                                                <!-- Referencia : {{ object.person.referencia }} -->
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div
                                class="md:col-span-1 my-auto bg-rose-600 rounded-lg shadow-lg p-6 h-full text-center flex justify-center items-center">
                                <div>
                                    <span class="text-white font-bold">Clase</span><br>
                                    <span class="text-[30px] lg:text-[50px] text-white font-bold">{{
                                        object.level ? object.level.label_short : ''
                                    }}</span><br>
                                    <span class="text-white font-bold">{{ object.classroom ? object.classroom.label : ''
                                    }}</span><br>
                                </div>

                            </div>
                            <div class="md:col-span-3 h-full">
                                <div class="grid h-full">
                                    <div class="flex justify-center pb-4">
                                        <div class="flex flex-row max-w-xl rounded-lg bg-white shadow-lg relative w-full">
                                            <img class="md:h-auto object-cover w-24 lg:w-44 rounded-l-lg"
                                                src="/img/student/tutor.png" alt="" />
                                            <div class="p-6 flex flex-col">
                                                <div class="flex items-center h-full justify-start">
                                                    <div>
                                                        <h5 class="text-gray-900 text-xl font-bold mb-2"><!-- Tutor -->-</h5>
                                                        <p class="text-gray-700 text-base">
                                                            -
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex justify-center">
                                        <div
                                            class="flex flex-row max-w-xl rounded-lg shadow-lg relative w-full my-auto h-auto">
                                            <div class="basis-1/2 md:h-auto my-auto object-cover rounded-l-lg bg-white p-6">

                                                <h5 class="text-gray-900 text-xl font-bold">Fecha de Matricula</h5>
                                            </div>
                                            <div class="basis-1/2 p-6 text-center w-full bg-rose-600 rounded-r-lg">
                                                <div class="flex items-center h-full justify-center">
                                                    <p class="text-white text-md font-bold">
                                                        {{ object.fecha_matricula }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container my-4">
                            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-4">
                                <div class="col-span-1 md:col-span-2 lg:col-span-5">
                                    <div class="bg-white rounded-lg shadow-lg p-6 h-full">
                                        <h3 class="md:text-2xl text-xl mt-4 mb-4 font-bold">Detalles Personales</h3>

                                        <div class="grid lg:grid-cols-2 md:grid-cols-2 md:gap-4 gap-2">
                                            <!--<div
                                                        class="flex items-star justify-between rounded-md mb-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                                        <div class="flex gap-3">
                                                            <div>
                                                                <div
                                                                    class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-sky-500 focus:shadow-outline hover:bg-sky-700">
                                                                    <BaseIcon :path="mdiPill" :size="24" />
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <h3 class="font-semibold text-lg">Referencia de domicilio</h3>
                                                                <p class="text-sm pt-0.5">Vive en el algun
                                                                    lugar{{ object.person.referencia }}</p>
                                                            </div>
                                                        </div>
                                                    </div>-->
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-sky-500 rounded-lg focus:shadow-outline hover:bg-sky-700">
                                                    <BaseIcon :path="mdiHomeSearch" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Referencia de domicilio</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>{{ object.person.referencia }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-lime-500 rounded-lg focus:shadow-outline hover:bg-lime-700">
                                                    <BaseIcon :path="mdiCradle" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Fecha de nacimiento</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ object.person.fecha_nacimiento }}, Distrito : {{
                                                            object.person.id_distrito_nacimiento ? distritos.find(item =>

                                                                item.id === object.person.id_distrito_nacimiento).label : ''
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-rose-500 rounded-lg focus:shadow-outline hover:bg-rose-700">
                                                    <BaseIcon :path="mdiTownHall" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Colegio de procedencia</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>
                                                            {{ object.id_colegio_procedencia ? colegios.find(item =>
                                                                item.id ===
                                                                object.id_colegio_procedencia).label : ''
                                                            }}
                                                            Distrito {{ object.id_distrito_colegio ?
                                                                distritos.find(item =>
                                                                    item.id === object.id_distrito_colegio).label : ''
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                    <BaseIcon :path="mdiCross" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Religión </h3>
                                                    <div>{{ object.id_religion ?
                                                        religions.find(item => item.id === object.id_religion).label :
                                                        ''
                                                    }}</div>

                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> Exonerado? {{ object.exonerado_religion ? 'Si' : 'No' }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-yellow-400 rounded-lg focus:shadow-outline hover:bg-yellow-600">
                                                    <BaseIcon :path="mdiPill" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Alergia a algún medicamento?</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ object.alergia ?? 'No' }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-green-500 rounded-lg focus:shadow-outline hover:bg-green-700">
                                                    <BaseIcon :path="mdiMedicalBag" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Alguna enfermedad a considerar
                                                    </h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ object.enfermedad ?? 'No' }} </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-fuchsia-500 rounded-lg focus:shadow-outline hover:bg-fuchsia-700">
                                                    <BaseIcon :path="mdiGymnastics" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">¿Apto para educación física?</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ object.apto_edu_fisica ? 'Si' : 'No' }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-red-600 rounded-lg focus:shadow-outline hover:bg-red-800">
                                                    <BaseIcon :path="mdiWater" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">¿Tamisaje de hemoglobina? </h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>{{ object.tamisaje_hemoglobina ?
                                                            'Realizado y entregado' :
                                                            'Pendiente con compromiso'
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-orange-400 rounded-lg focus:shadow-outline hover:bg-orange-700">
                                                    <BaseIcon :path="mdiPuzzleRemove" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Problemas de aprendizaje</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ object.obs_aprendizaje ?? 'No' }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-amber-400 rounded-lg focus:shadow-outline hover:bg-amber-600">
                                                    <BaseIcon :path="mdiCheckDecagram" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Tipo</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>{{ object.type ? 'Antiguo' : 'Nuevo' }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                    <BaseIcon :path="mdiCreditCardOutline" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Estado financiero</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>{{ object.status_financiero ? 'Al día' : 'Pago pendiente'
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                    <BaseIcon :path="mdiInformationOutline" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Log</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>Modif. Card: {{ user_modif ? user_modif.name : '' }} {{
                                                            object.updated_at ? formatDateTime(object.updated_at) : '' }} {{
                                                                user_modif_status ? 'Modif. Status:' + user_modif_status.name :
                                                                ''
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Otra información -->
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <div>
                                                    <span class="font-bold mr-2">Código UGEL : </span>{{ object.ref_ugel}}<br>
                                                    <span class="font-bold mr-2">Fecha de retiro : </span>{{ object.fecha_retiro ? formatDate(object.fecha_retiro) : ''}}<br>
                                                    <span class="font-bold mr-2">Fecha de reingreso : </span>{{ object.fecha_reingreso ? formatDate(object.fecha_reingreso) : ''}}<br>
                                                    <span class="font-bold mr-2">Nota : </span>{{ object.note }}
                                                   
                                                </div>
                                            </div>
                                            <div v-if="$page.props.auth.user.id_rol <= 4" class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                
                                                <div>
                                                    <div>
                                                    <span class="font-bold mr-2">Pensión preferencial : </span>{{ object.pension_preferencial}}<br>
                                                    <span class="font-bold mr-2">Becado : </span>{{ object.becado ? 'Si' : 'No'}}<br>
                                                    <span class="font-bold mr-2">Compromiso de pago : </span>{{ object.fecha_compromiso_pago ? formatDate(object.fecha_compromiso_pago) : ''}}<br>
                                                    <span class="font-bold mr-2">Nota Financiera : </span>{{ object.financial_note }}
 
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-span-1 md:col-span-2 lg:col-span-3">
                                    <div class="bg-white rounded-lg shadow-lg p-6 h-full">

                                        <div class="flex flex-col items-center h-full w-full justify-center">
                                            <div class="w-full text-left">
                                                <h3 class="md:text-2xl text-xl mt-4 mb-4 font-bold">Gráfica de competencias
                                                </h3>
                                                <!-- <select @change="listarChartCalification(this.value)">
                                                            <option value="" disabled>Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B1'" selected>Primer Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B2'" selected>Segundo Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B3'" selected>Tercer Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B4'" selected>Cuarto Bimestre</option>
                                                        </select> -->
                                            </div>

                                            <div class="my-auto w-full">
                                                <CardBox class="w-full">
                                                    <!-- {{ chartCalifications }} -->
                                                    <div v-if="chartCalifications">
                                                        <radar-chart :data="chartCalifications"
                                                            class="min-w-[100%]" /><!-- class="h-96" con w-full no queda muy bien -->
                                                    </div>
                                                    <div v-else>
                                                        No existen notas ...
                                                    </div>
                                                </CardBox>
                                            </div>
                                            <!--{{ chartCompetencias }}-->


                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="canWrite" class="flex justify-end">
                            <!-- Aceso desde AdminCoord -->
                            <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                <div class="col-span-1">
                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                        label=" Modificar" class="w-full" />
                                                </div>
                                                <div class="col-span-1">
                                                    <BaseButton v-if="object.status" color="danger"
                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                            <div class="rounded-lg bg-white shadow-lg p-6 gap-4 lg:w-auto w-full">
                                <div class="grid lg:grid-cols-2 gap-4"><!-- <-- cols-4 para cuatro botones o 3  -->
                                    <!-- <div class="col-span-1">
                                                <BaseButton color="info" :icon="mdiPencil"
                                                    label=" Modificar" class="w-full" />
                                            </div>
                                            <div class="col-span-1">
                                                <BaseButton color="success" :icon="mdiPencil" 
                                                    label=" Modificar" class="w-full" />
                                            </div> -->
                                    <div class="col-span-1">
                                        <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                            label=" Modificar" class="w-full" />
                                    </div>
                                    <div class="col-span-1">
                                        <BaseButton v-if="object.status" color="danger" @click="initModal('desactivar')"
                                            label="Deshabilitar (retirado)" class="w-full" />
                                        <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                            @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- Editar -->
                    <template v-else-if="action == 'edit' && canWrite">
                        <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar</h3>
                            <form @submit.prevent="submit">
                                <FormField label="Apellidos y Nombres">
                                    <FormControl v-model="form.apellidos" name="apellidos" type="text" required />
                                    <FormControl v-model="form.nombres" name="nombres" type="text" required />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero"
                                        placeholder="Género" />
                                </FormField>
                                <FormField label="Fecha de matrícula / Documento">
                                    <FormControl v-model="form.fecha_matricula" type="date" />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="form.num_doc" name="num_doc" type="text" required />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="form.domicilio" name="direccion" type="text" placeholder="Dirección" />
                                    <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos"
                                        placeholder="Distrito" />
                                    <FormControl v-model="form.referencia"  name="referencia_domicilio" type="text"
                                        placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="form.fecha_nacimiento" type="date" />
                                    <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos"
                                        placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de estudiante -->
                                <FormField label="Sede/Colegio de procedencia">
                                    <FormControl v-model="form.sede_origen" type="select" :options="sedes"
                                        placeholder="Sede Origen" />
                                    <FormControl v-model="form.id_colegio_procedencia" type="select" :options="colegios"
                                        placeholder="Colegios" />
                                    <FormControl v-model="form.id_distrito_colegio" type="select" :options="distritos"
                                        placeholder="Distrito" />
                                </FormField>
                                <FormField label="Religión / Exonerado"
                                    help="Detalle si congrega una religión y si desea ser exonerado del curso de religión">
                                    <FormControl v-model="form.id_religion" type="select" :options="religions"
                                        placeholder="Escoja una Religión" />
                                    <FormControl v-model="form.exonerado_religion" type="yesno" placeholder="exonerado" />
                                </FormField>
                                <FormField label="Datos de salud del estudiante"
                                    help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                    <FormControl v-model="form.alergia" type="text"
                                        labelinput="Alérgico a algun medicamento" />
                                    <FormControl v-model="form.enfermedad" type="text"
                                        labelinput="Alguna enfermedad a considerar" />
                                    <FormControl v-model="form.apto_edu_fisica" type="yesno" placeholder="es apto"
                                        labelinput="Apto para educación física" />
                                    <FormControl v-model="form.tamisaje_hemoglobina" type="select"
                                        :options="optionsTamizaje" placeholder="Escoja una opción"
                                        labelinput="Tamizaje de hemoglobina" />
                                </FormField>
                                <FormField label="Vacunas"
                                    help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                    <FormControl v-model="form.vacuna_pentavalente" type="yesno" placeholder="está vacunado"
                                        labelinput="Pentavalente" />
                                    <FormControl v-model="form.vacuna_odpt" type="yesno" placeholder="está vacunado"
                                        labelinput="O DPT" />
                                </FormField>
                                <FormField label="Otros casos a considerar">
                                    <FormControl v-model="form.obs_aprendizaje" type="text"
                                        labelinput="Problemas de aprendizaje" />
                                    <FormControl v-model="form.aprendizaje_terapia" type="yesno"
                                        placeholder="está en terapia" labelinput="Terapia" />
                                    <FormControl v-model="form.obs_otros" type="text" labelinput="Otros" />
                                </FormField>
                                <FormField label="Seguro de salud"
                                    :help="form.obs_seguro_salud = selectSeguroSalud + ' : ' + textSeguroSalud">
                                    <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud" />
                                    <FormControl v-model="textSeguroSalud" type="text"
                                        :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional'" />
                                </FormField>
                                <FormField label="Situación familiar"
                                    :help="form.obs_situacion_familiar = selectSituacionFamiliar + ' : ' + textSituacionFamiliar">
                                    <FormControl v-model="selectSituacionFamiliar" type="select"
                                        :options="optionsSituacionFamiliar" />
                                    <FormControl v-model="textSituacionFamiliar" type="text"
                                        :placeholder="selectSituacionFamiliar == optionsSituacionFamiliar[0] ? 'Cantidad de hermanos' : (selectSituacionFamiliar == optionsSituacionFamiliar[3] ? 'Especificar' : 'Información opcional')" />
                                </FormField>
                                <FormField label="Datos de la vivienda"
                                    :help="form.obs_datos_vivienda = selectVivienda + ' : ' + textVivienda">
                                    <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" />
                                    <FormControl v-model="textVivienda" type="text" placeholder="Información adicional" />
                                </FormField>

                                <FormField label="Estado civil de los padres">
                                    <FormControl v-model="form.id_estado_civil_padres" type="select"
                                        :options="estadoCiviles" placeholder="Escoja una opción" />
                                    <FormControl v-model="form.obs_estado_padres" type="text"
                                        placeholder="Observación adicional" />
                                </FormField>
                                <FormField label="Datos académicos">
                                    <FormControl v-model="form.id_level" type="select" :options="levels"
                                        placeholder="Escoja una opción" labelinput="Nivel/Grado de estudio" />
                                    <FormControl v-model="form.id_classroom" type="select" :options="classrooms"
                                        placeholder="Escoja una opción" labelinput="Aula de estudio" />
                                    <FormControl v-model="form.id_classroom_matricula" type="select" :options="classrooms"
                                        placeholder="Escoja una opción" labelinput="Aula matrícula" />
                                    <FormControl v-model="form.id_classroom_ugel" type="select" :options="teoricClassrooms"
                                        placeholder="Escoja una opción" labelinput="Aula Ugel" />
                                </FormField>
                                <FormField label="">
                                    <FormControl v-model="form.ref_ugel" type="text" labelinput="Código UGEL" />
                                    <FormControl v-model="form.fecha_retiro" type="date" labelinput="Fecha retiro" />
                                    <FormControl v-model="form.fecha_reingreso" type="date" labelinput="Fecha reingreso" />
                                </FormField>
                                <FormField label="Nota">
                                    <FormControl v-model="form.note" type="textarea" labelinput="Otra información" />
                                </FormField>
                                <!-- No mostrar a secretaria -->
                                <FormField :hidden="$page.props.auth.user.id_rol == 6" label="Financiera">
                                    <FormControl v-model="form.financial_note" type="textarea" labelinput="Nota financieras" />
                                    <FormControl v-model="form.pension_preferencial" type="number"
                                        labelinput="Pensión preferencial"
                                        :tooltipcontent="'Ingresar un monto si tiene pensión preferencial'" />
                                    <FormControl v-model="form.becado" type="yesno" labelinput="Becado?"
                                        :tooltipcontent="'No se genera órdenes de pago'" />
                                    <FormControl v-model="form.fecha_compromiso_pago" type="date" labelinput="Fecha de compromiso de pago"/>
                                </FormField>
                                <FormField :hidden="$page.props.auth.user.id_rol == 6" label="Restablecer datos de Login"><!-- :isoneintwo="true" -->
                                    <FormControl v-model="form.change_login" type="yesno"
                                        labelinput="Cambiar email y password por defecto?"
                                        :tooltipcontent="'Por defecto el usuario es DOCUMENTO' + confGlobal.value.USER_EMAIL_DEFAULT_SUFIJO + ' y el password es el DOCUMENTO'" />
                                    
                                </FormField>
                                
                                <div class="flex items-center justify-end mt-4">
                                    <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                    <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>

                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }"
                                        :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear sólo desde el botón return dashboard-->
                    <template v-else-if="action == 'create'">
                        <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Agregar nuevo estudiante</h3>
                            <form @submit.prevent="submit">
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="form.apellidos" name="apellidos" type="text" required placeholder="Apellidos" />
                                    <FormControl v-model="form.nombres" name="nombres" type="text" required placeholder="Nombres" />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero"
                                        placeholder="Género" />
                                </FormField>
                                <FormField label="Fecha de matrícula / Documento" required>
                                    <FormControl v-model="form.fecha_matricula" type="date" />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="form.num_doc" name="num_doc" type="text" required />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="form.telefono" name="telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" name="celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.email" name="email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="form.domicilio" name="direccion" type="text" placeholder="Dirección" />
                                    <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos"
                                        placeholder="Distrito" />
                                    <FormControl v-model="form.referencia" type="text"
                                        placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="form.fecha_nacimiento" type="date" />
                                    <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos"
                                        placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de estudiante -->
                                <FormField label="Sede/Colegio de procedencia">
                                    <FormControl v-model="form.sede_origen" type="select" :options="sedes"
                                        placeholder="Sede Origen" />
                                    <FormControl v-model="form.id_colegio_procedencia" type="select" :options="colegios"
                                        placeholder="Colegios" />
                                    <FormControl v-model="form.id_distrito_colegio" type="select" :options="distritos"
                                        placeholder="Distrito" />
                                </FormField>

                                <FormField label="Datos académicos">
                                    <FormControl v-model="form.id_level" type="select" :options="levels"
                                        placeholder="Escoja una opción" labelinput="Nivel/Grado de estudio" />
                                    <FormControl v-model="form.id_classroom" type="select" :options="classrooms"
                                        placeholder="Escoja una opción" labelinput="Aula de estudio" />
                                    <FormControl v-model="form.id_classroom_matricula" type="select" :options="classrooms"
                                        placeholder="Escoja una opción" labelinput="Aula matrícula" />
                                    <FormControl v-model="form.id_classroom_ugel" type="select" :options="teoricClassrooms"
                                        placeholder="Escoja una opción" labelinput="Aula Ugel" />
                                </FormField>

                                <FormField v-if="confGlobal.value.FINANCIERA_CREAR_ORDEN_PAGO_TO_CREAR_STUDENT == 1" label="Datos financieros">
                                    <FormControl v-model="form.becado" type="yesno" labelinput="Becado? No se realizará seguimientos de pagos" />
                                </FormField>

                                <!-- Crear orden de pago -->
                                <div v-if="confGlobal.value.FINANCIERA_CREAR_ORDEN_PAGO_TO_CREAR_STUDENT == 1 && form.becado == 0" class="my-auto inline-flex items-center">
                                    <span class="inline-flex font-semibold text-yellow-600" @click="form.crear_orden_pago = !form.crear_orden_pago">
                                        <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                        Crear órdenes para el seguimiento de pagos [+]
                                    </span>
                                </div>  
                                <div v-if="form.crear_orden_pago && form.becado == 0" class="border-l-2 border-yellow-600  bg-white leading-normal p-6">
                                    <div>
                                        <ul>
                                            <li>Asegúrese de la orden de pago sea del año correcto (si se matricula para este año o para el próximo año).</li>
                                            <li>Matrícula inicial: <b>{{ confGlobal.value.PRECIO_MATRICULA_INICIAL }}</b>, Matrícula primaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_PRIMARIA }}</b>,
                                                Matrícula secundaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_SECUNDARIA }}</b>, Pensión inicial:
                                                <b>{{ confGlobal.value.PRECIO_PENSION_INICIAL }}</b>, Pensión primaria: <b>{{ confGlobal.value.PRECIO_PENSION_PRIMARIA }}</b>
                                                , Pensión secundaria: <b>{{ confGlobal.value.PRECIO_PENSION_SECUNDARIA }}</b> </li>
                                            <li>La pensión preferencial sólo se ingresa si el pago de pensión es distinto al establecido, de lo contrario lo deja en cero</li>
                                        </ul>
                                    </div>
                                    <div class="grid-cols-4 flex items-center my-4">
                                        <div class="relative">
                                            <label class="mr-3" for="orderAnio"> Año </label>
                                            <select id="orderAnio" class="mb-3 rounded-lg mr-3" v-model="form.orderAnio">
                                                <option :value="anioEscolar">{{ anioEscolar }}</option>
                                                <option :value="parseInt(anioEscolar)+1">{{ parseInt(anioEscolar)+1 }}</option>
                                            </select>
                                        </div>
                                        <div class="relative">
                                            <label class="mr-3" for="pensionPreferencial">Pensión preferencial</label>
                                            <input class="mb-3 rounded-lg" id="pensionPreferencial" v-model="form.pension_preferencial" type="number">
                                        </div>
                                    </div>

                                    <div class="mt-1 w-full label-clean xl:flex flex-row justify-between grid lg:grid-cols-6 sm:grid-cols-2 grid-cols-1">
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxmatricula" class="mr-2" v-model="form.order13" />
                                            <label for="chxmatricula" class="">Matricula</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxmarzo" class="mr-2" v-model="form.order03" />
                                            <label for="chxmarzo">Marzo</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxabril" class="mr-2" v-model="form.order04" />
                                            <label for="chxabril">Abril</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxmayo" class="mr-2" v-model="form.order05" />
                                            <label for="chxmayo">Mayo</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxjunio" class="mr-2" v-model="form.order06" />
                                            <label for="chxjunio">Junio</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxjulio" class="mr-2" v-model="form.order07" />
                                            <label for="chxjulio">Julio</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxagosto" class="mr-2" v-model="form.order08" />
                                            <label for="chxagosto">Agosto</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxsetiembre" class="mr-2" v-model="form.order09" />
                                            <label for="chxsetiembre">Setiembre</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxoctubre" class="mr-2" v-model="form.order10" />
                                            <label for="chxoctubre">Octubre</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxnoviembre" class="mr-2" v-model="form.order11" />
                                            <label for="chxnoviembre">Noviembre</label>
                                        </div>
                                        <div class="flex items-center">
                                            <input type="checkbox" id="chxdiciembre" class="mr-2" v-model="form.order12" />
                                            <label for="chxdiciembre">Diciembre</label>
                                        </div>

                                    </div>

                                </div>

                                <div class="flex items-center justify-end mt-4">

                                    <!-- <Link :href="route('student')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Volver al listado
                                            </Link> -->
                                    <!-- <BaseButton
                                                color="contrast"
                                                :href="route('student')"
                                                small
                                                label=" Cancelar"
                                                class="ml-4"
                                            /> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>
                                    <span v-if="form.order13 && !form.fecha_matricula" class="ml-3 font-medium text-red-600">Debe asignar fecha de matrícula</span>
                                    <span v-else-if="form.crear_orden_pago && !form.id_level" class="ml-3 font-medium text-red-600">Debe asignar un nivel/grado de estudio</span>
                                    <BreezeButton v-else class="ml-4" :class="{ 'opacity-25': form.processing }"
                                        :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>

                </template>
                <!-- Apoderado -->
                <template v-else-if="(tab == 1)">
                    <template v-if="action == 'view_apoderado'">
                        <!-- <div class="col-span-1 text-right mb-2">
                            <BaseButton color="info" :icon="mdiPlusCircle" @click="action = 'create_apoderado'"
                                label=" Crear Contacto" class="" />
                        </div> -->
                        <div v-for="(contacto, index) in apoderados" :key="contacto.id" class="container mb-4">
                            <div class="grid grid-cols-1 gap-4">
                                <div class="col-span-1">

                                    <div class="bg-white rounded-lg shadow-lg p-6 h-full w-full">
                                        <!-- <h3 class="md:text-2xl text-xl mt-4 mb-4 font-bold">Datos Personales</h3> -->
                                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                    <BaseIcon :path="mdiAccountSupervisor" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Parentesco </h3>
                                                    <div>{{ contacto.id_parentesco ?
                                                        parentescos.find(item => item.id === contacto.id_parentesco).label
                                                        :
                                                        ''
                                                    }}</div>


                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-sky-500 rounded-lg focus:shadow-outline hover:bg-sky-700">
                                                    <BaseIcon :path="mdiHomeSearch" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Referencia de domicilio</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div>{{ contacto.person.referencia }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                <button
                                                    class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-lime-500 rounded-lg focus:shadow-outline hover:bg-lime-700">
                                                    <BaseIcon :path="mdiCradle" :size="28" />
                                                </button>
                                                <div>
                                                    <h3 class="font-semibold text-lg">Fecha de nacimiento</h3>
                                                    <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                        <div> {{ contacto.person.fecha_nacimiento }}, Distrito : {{
                                                            contacto.person.id_distrito_nacimiento ? distritos.find(item =>

                                                                item.id === contacto.person.id_distrito_nacimiento).label : ''
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="grid lg:grid-cols-2 md:grid-cols-2 md:gap-4 gap-2">
                                            <div class="col-span-1 h-auto my-auto">
                                                <div class="flex items-center h-full justify-start">
                                                    <div>
                                                        <span class="text-lg font-bold">Nombre: </span>{{
                                                            contacto.person.apellidos + ' ' + contacto.person.nombres
                                                        }}<br>
                                                        <span class="font-bold mr-2">DNI : </span>{{
                                                            contacto.person.num_doc }}
                                                        <br>
                                                        <span class="font-bold mr-2">Género : </span>{{
                                                            contacto.person.sexo ?
                                                            'Masculino' :
                                                            'Femenino'
                                                        }}<br>
                                                        <span class="font-bold mr-2">Teléfono : </span> {{
                                                            contacto.person.telefono
                                                        }}, celular : {{ contacto.person.celular }}
                                                        <a :href="'https://wa.me/+51'+contacto.person.celular+'?text=Hola'" target="_blank">
                                                            <BaseIcon :path="mdiWhatsapp" class="text-green-700" :size="14" />
                                                        </a><br>
                                                        <span class="font-bold mr-2">Email : </span> {{
                                                            contacto.person.email }}<br>
                                                        <span class="font-bold mr-2">Dirección : </span> {{
                                                            contacto.person.domicilio
                                                        }}, distrito : {{
                                                            contacto.person.id_distrito_domicilio ? distritos.find(item =>
                                                                item.id ===
                                                                contacto.person.id_distrito_domicilio).label : ''
                                                        }}<br>
                                                        <!-- <span class="font-bold mr-2">Login : </span> 
                                                                {{ user.email }}<br>
                                                                <span class="font-bold mr-2">User : </span> 
                                                                {{ user.user }} (clave default = DNI) -->
                                                        <!-- Referencia : {{ object.person.referencia }} -->
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-span-1 h-auto my-auto">
                                                <div class="flex items-center h-full justify-start">
                                                    <div>
                                                        <span class="font-bold mr-2">Tipo : </span>{{
                                                            contacto.type ? 'Responsable de pagos' : '' }}
                                                        <br>
                                                        <span class="font-bold mr-2">Ocupación : </span>{{
                                                            contacto.ocupation }}
                                                        <br>
                                                        <span class="font-bold mr-2">Trabajo : </span>{{
                                                            contacto.trabajo 
                                                        }}<br>
                                                        <span class="font-bold mr-2">Horario Laboral : </span>{{
                                                            contacto.horario_laboral
                                                        }}<br>
                                                        <span class="font-bold mr-2">Teléfono Trabajo : </span> {{
                                                            contacto.telefono_trabajo
                                                        }}, celular trabajo : {{ contacto.celular_trabajo }}<br>
                                                        <!-- <span class="font-bold mr-2">Email : </span> {{
                                                            contacto.person.email }}<br> -->
                                                        <span class="font-bold mr-2">Nota : </span> {{
                                                            contacto.note
                                                        }}<!-- , distrito : {{
                                                            contacto.person.id_distrito_domicilio ? distritos.find(item =>
                                                                item.id ===
                                                                contacto.person.id_distrito_domicilio).label : ''
                                                        }}<br> -->
                                                        <!-- <span class="font-bold mr-2">Login : </span> 
                                                                {{ user.email }}<br>
                                                                <span class="font-bold mr-2">User : </span> 
                                                                {{ user.user }} (clave default = DNI) -->
                                                        <!-- Referencia : {{ object.person.referencia }} -->
                                                    </div>
                                                </div>
                                            </div>



                                            <!-- <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                            <BaseIcon :path="mdiAccountSupervisor" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Parentesco </h3>
                                                            <div>{{ contacto.id_parentesco ?
                                                                    parentescos.find(item => item.id === contacto.id_parentesco).label :
                                                                    ''
                                                            }}</div>
                                                            
                                                            
                                                        </div>
                                                    </div> -->
                                            <!-- <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                            <BaseIcon :path="mdiInformationOutline" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Log</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>Modif. Card: {{ user_modif ? user_modif.name : '' }} {{ object.updated_at ? formatDateTime(object.updated_at) : '' }} {{ user_modif_status ? 'Modif. Status:'+user_modif_status.name : '' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                        </div>

                                        <div v-if="canWrite" class="flex justify-end"><!-- Secretaria 6 -->
                                            <!-- Aceso desde AdminCoord -->
                                            <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                                <div class="col-span-1">
                                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                                        label=" Modificar" class="w-full" />
                                                                </div>
                                                                <div class="col-span-1">
                                                                    <BaseButton v-if="object.status" color="danger"
                                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->

                                            <div v-if="contacto" class="rounded-lg bg-white shadow-lg p-6 gap-4 lg:w-auto w-full">
                                                <div class="grid lg:grid-cols-2 gap-4"><!-- <-- cols-4 para cuatro botones o 3  -->
                                                    <!-- <div class="col-span-1">
                                                                <BaseButton color="info" :icon="mdiPencil"
                                                                    label=" Modificar" class="w-full" />
                                                            </div>
                                                            <div class="col-span-1">
                                                                <BaseButton color="success" :icon="mdiPencil" 
                                                                    label=" Modificar" class="w-full" />
                                                            </div> -->
                                                    <div class="col-span-1">
                                                        <BaseButton color="warning" :icon="mdiPencil" @click="(actualizarContacto(contacto)), (action = 'edit_apoderado')"
                                                            label=" Modificar" class="w-full" />
                                                    </div>
                                                    <!-- Establecer contacto por defecto -->
                                                    <!-- <div class="col-span-1">
                                                                <BaseButton v-if="object.status" color="danger"
                                                                    @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                                <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                                    @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                            </div> -->
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                

                            </div>

                        </div>
                        
                    </template>
                    <!-- Editar apoderado -->
                    <template v-else-if="action == 'edit_apoderado' && canWrite">
                        <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar apoderado de {{ object.person.apellidos + ' ' + object.person.nombres }}</h3>
                            <form @submit.prevent="submitApoderado">
                                <FormField label="Apellidos y Nombres">
                                    <FormControl v-model="formApoderado.apellidos" type="text" required />
                                    <FormControl v-model="formApoderado.nombres" type="text" required />
                                    <FormControl v-model="formApoderado.sexo" type="select" :options="optionsGenero"
                                        placeholder="Género" />
                                </FormField>
                                <FormField label="Parentesco / Documento">
                                    <FormControl v-model="formApoderado.id_parentesco" type="select" required :options="parentescos"
                                        placeholder="Parentesco" />
                                    <FormControl v-model="formApoderado.id_type_document" type="select"
                                        :options="typeDocuments" />
                                    <FormControl v-model="formApoderado.num_doc" type="text" required />
                                    <FormControl v-model="formApoderado.type" type="select" placeholder="Tipo de apoderado"
                                        :options="typeContacts" />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="formApoderado.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="formApoderado.email" type="email" :icon="mdiMail"
                                        placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="formApoderado.domicilio" type="text" placeholder="Dirección" />
                                    <FormControl v-model="formApoderado.id_distrito_domicilio" type="select"
                                        :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="formApoderado.referencia" type="text"
                                        placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="formApoderado.fecha_nacimiento" type="date" />
                                    <FormControl v-model="formApoderado.id_distrito_nacimiento" type="select"
                                        :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de apoderado -->

                                <FormField label="Información laboral" help="">
                                    <FormControl v-model="formApoderado.ocupation" type="text"
                                        labelinput="Profesión o a qué se dedica" />
                                    <FormControl v-model="formApoderado.trabajo" type="text" labelinput="Centro laboral" />
                                    <FormControl v-model="formApoderado.horario_laboral" type="text"
                                        labelinput="Horario de trabajo" />

                                </FormField>
                                <FormField label="Información de contacto laboral">
                                    <FormControl v-model="formApoderado.telefono_trabajo" type="tel"
                                        placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular_trabajo" type="tel" placeholder="Celular" />
                                    <!-- <FormControl v-model="formApoderado.email_trabajo" type="email" :icon="mdiMail" placeholder="Email"/> -->
                                </FormField>

                                <!-- <FormField label="Restablecer datos de Login / Pensión" :isoneintwo="true">
                                            <FormControl v-model="form.change_login" type="yesno" labelinput="Cambiar email y password por defecto?" :tooltipcontent="'Por defecto el usuario es DOCUMENTO'+confGlobal.value.USER_EMAIL_DEFAULT_SUFIJO+' y el password es el DOCUMENTO'"/>
                                            <FormControl v-model="form.pension_preferencial" type="number" labelinput="Pensión preferencial" :tooltipcontent="'Ingresar un monto si tiene pensión preferencial'"/>
                                            <FormControl v-model="form.becado" type="yesno" labelinput="Becado?" :tooltipcontent="'No se genera órdenes de pago'"/>
                                        </FormField> -->
                                <FormField label="Nota">
                                    <FormControl v-model="formApoderado.note" type="textarea"
                                        labelinput="Otra información" />
                                </FormField>
                                <div class="flex items-center justify-end mt-4">
                                    <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                    <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>

                                    <BreezeButton  class="ml-4" :class="{ 'opacity-25': form.processing }"
                                        :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear apoderado -->
                    <template v-else-if="action == 'create_apoderado' && canWrite">
                        <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Agregar apoderado a {{ object.person.apellidos + ' ' + object.person.nombres  }}</h3>
                            <span v-if="existeContacto" class="font-semibold text-red-600 leading-tight">Ya existe una persona con el mismo Documento, se agregará esta persona como contacto!</span>
                            <form @submit.prevent="submitApoderado">
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="formApoderado.apellidos" name="apellidos" type="text" required
                                        placeholder="Apellidos" />
                                    <FormControl v-model="formApoderado.nombres" name="nombres" type="text" required
                                        placeholder="Nombres" />
                                    <FormControl v-model="formApoderado.sexo" name="genero" type="select"
                                        :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Parentesco / Documento" required>
                                    <!-- v-model="formApoderado.fecha_matricula" type="date" -->
                                    <FormControl v-model="formApoderado.id_parentesco" required type="select" :options="parentescos"
                                        placeholder="Parentesco" />
                                    <FormControl v-model="formApoderado.id_type_document" type="select"
                                        :options="typeDocuments" />
                                    <FormControl v-model="formApoderado.num_doc" name="num_doc" type="text" required @change="getContactForDoc(formApoderado.num_doc)"/>
                                    <FormControl v-model="formApoderado.type" type="select" placeholder="Tipo de apoderado"
                                        :options="typeContacts" />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="formApoderado.telefono" name="telefono" type="tel"
                                        placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular" name="celular" type="tel"
                                        placeholder="Celular" />
                                    <FormControl v-model="formApoderado.email" name="email" type="email" :icon="mdiMail"
                                        placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="formApoderado.domicilio" name="direccion" type="text"
                                        placeholder="Dirección" />
                                    <FormControl v-model="formApoderado.id_distrito_domicilio" type="select"
                                        :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="formApoderado.referencia" name="ref_domicilio" type="text"
                                        placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="formApoderado.fecha_nacimiento" type="date" />
                                    <FormControl v-model="formApoderado.id_distrito_nacimiento" type="select"
                                        :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de estudiante -->
                                <!-- <FormField label="Colegio de procedencia">
                                            <FormControl v-model="formApoderado.id_parentesco" type="select" :options="parentescos" placeholder="Parentesco" />
                                            <FormControl v-model="formApoderado.id_distrito_colegio" type="select" :options="distritos" placeholder="Distrito" />
                                        </FormField> -->
                                <!-- <FormField label="Religión / Exonerado" help="Detalle si congrega una religión y si desea ser exonerado del curso de religión">
                                            <FormControl v-model="form.id_religion" type="select" :options="religions" placeholder="Escoja una Religión" />
                                            <FormControl v-model="form.exonerado_religion" type="yesno" placeholder="exonerado" />
                                        </FormField>
                                        <FormField label="Datos de salud del estudiante" help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                            <FormControl v-model="form.alergia" type="text" labelinput="Alérgico a algun medicamento" />
                                            <FormControl v-model="form.enfermedad" type="text"  labelinput="Alguna enfermedad a considerar"/>
                                            <FormControl v-model="form.apto_edu_fisica" type="yesno" placeholder="es apto" labelinput="Apto para educación física" />
                                            <FormControl v-model="form.tamisaje_hemoglobina" type="select" :options="optionsTamizaje" placeholder="Escoja una opción" labelinput="Tamizaje de hemoglobina" />
                                        </FormField> -->



                                <div class="flex items-center justify-end mt-4">



                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>
                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }"
                                        :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                </template>
                <!-- <template v-else-if="(tab == 1)">
                            <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Informe de progreso</h3>
                            Informe de progreso
                            </div>
                        </template>
                        <template v-else-if="(tab == 2)">
                            <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Portafolio</h3>
                            Portafolio
                            </div>
                        </template>
                        <template v-else-if="(tab == 3)">
                            <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Anecdotario</h3>
                                Anecdotario
                            </div>
                        </template>
                        <template v-else-if="(tab == 4)">
                            <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Carpeta de recuperación</h3>
                                Carpeta de recuperación
                            </div>
                        </template> -->

                <!-- Información académica -->
                <template v-else-if="(tab == 2)">
                    <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                        <h6 class="md:text-lg text-sm my-4 font-bold">{{ object.person.apellidos + ' ' +
                            object.person.nombres }} - Año de consulta

                            <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="anioSearch"
                                :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">

                        </h6>
                        <div class="grid grid-cols-1 gap-6 mb-6">
                            <div class="flex flex-col">
                                <!-- LRR justify-between para dos áreas con el mimos ancho o no se -->
                                <!--:date="client.created"-->
                                <!--{{ object.ciclos }} object.person.id_distrito_domicilio ? distritos.find(item => item.id === object.person.id_distrito_domicilio ).label : ''-->

                                <!-- Cursos -->
                                <div
                                    class="bg-white tab tab-gray w-full overflow-hidden border border-gray-200 rounded-lg mb-6">
                                    <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-alumnos"
                                        type="radio" name="tabs2">
                                    <label class="block p-5 leading-normal cursor-pointer bg-gray-100 content-center"
                                        for="tab-alumnos" style="height: 66px" @click="listarAdmisionPuntaje()">
                                        <div class="my-auto inline-flex items-center" style="height: 24px">
                                            <span class="inline-flex font-semibold text-gray-600">
                                                <BaseIcon :path="mdiFileDocumentMultipleOutline" :size="24" class="mr-3 " />
                                                Libreta / Cursos
                                            </span>
                                        </div>

                                    </label>
                                    <div
                                        class="tab-content overflow-hidden border-l-2 border-gray-600  bg-white leading-normal">
                                        <div class="p-5 grid gap-4 lg:max-h-max max-h-[600px] overflow-y-auto ">
                                            <CardBox class="mb-6" has-table>
                                                <BaseButtons type="justify-start" no-wrap><!--lg:justify-end-->
                                                    <BaseButton color="info" :icon="mdiPrinter" label="Libreta" small
                                                        :href="'/calification/libreta' + '?id=' + object.id + '&anioSearch=' + anioSearch"
                                                        target="_blank" />
                                                </BaseButtons>
                                            </CardBox>

                                            <!-- EAP -->
                                            <div v-if="haveEAP">
                                                <div class="font-bold text-lg mb-2">Simulacro tipo examen de admisión</div>
                                                <li>Para imprimir el diploma lo debe hacer en la sección Aula -> Puntajes
                                                    EAP. Debe filtrar por Bimestre y grado.</li>
                                                <li>Para cambiar el puntaje lo puede realizar en la sección Aula -> ingresa
                                                    al aula del estudiante y realice el cambio en puntajes de simulacro.
                                                </li>
                                                <div class="grid">
                                                    <div v-if="arrayAdmisionPuntaje.length"
                                                        v-for="client in arrayAdmisionPuntaje" :key="client.id"
                                                        class="grid grid-cols-4 bg-gray-100 py-2 px-4 mb-3 rounded-lg">

                                                        <div class="col-span-2 md:col-span-3 inline-flex items-center pt-2">
                                                            <!-- <BaseIcon v-if="client.type == 'PDF'" :path="mdiPaperclip" :size="32"
                                                                            class="text-red-600 mr-2" />
                                                                        <BaseIcon v-else :path="mdiPaperclip" :size="32" class="text-lime-600 mr-2" /> -->
                                                            <span>
                                                                {{ client.ref_ciclo }}
                                                            </span>
                                                            <span class="ml-2">

                                                                {{ client.label_eap }}
                                                            </span>
                                                            <span class="ml-2">

                                                                {{ client.puntaje }}
                                                            </span>
                                                            <span class="ml-2">
                                                                <small v-if="client.resultado == '1'"
                                                                    class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                                                    <span>Ingresó</span>
                                                                </small>
                                                                <small v-else-if="client.resultado == '2'"
                                                                    class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                                                    <span>Ausente</span>
                                                                </small>
                                                                <small v-else
                                                                    class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                                                    <span>No ingresó</span>
                                                                </small>
                                                            </span>
                                                        </div>
                                                        <!-- A futuro si es que se guarda el registro de ranking -->
                                                        <BaseButtons
                                                            v-if="confGlobal.value.INICIO_STUDENT_SHOW_PRINT_DIPLOMA == '1'"
                                                            type="justify-start lg:justify-end" no-wrap>

                                                            <BaseButton color="info" :icon="mdiPrinter" small
                                                                :href="'/admisionpuntaje/diploma' + '?id=' + client.id"
                                                                target="_blank" />


                                                        </BaseButtons>
                                                    </div>
                                                    <div v-else class="col-span-2 md:col-span-1 bg-gray-100 p-4 rounded-lg">
                                                        <span> No se registraron punajes de examen tipo admisión …</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="font-bold text-lg mb-2">No tiene un EAP asignado.</div>
                                                <li>Para asignar EAP lo puede hacer en el aula -> Listado de alumnos.</li>
                                            </div>
                                            <div v-if="cursos.length" class="overflow-x-auto">
                                                <div class="font-bold text-lg mb-2">Curos del nivel actual del estudiante
                                                </div>
                                                <li>Si es exonerado de religión en la libreta no se mostrará la nota</li>

                                                <table class="min-w-full text-sm font-light table-responsive-wfull">
                                                    <thead
                                                        class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                                        <tr>
                                                            <th scope="col" class="">#</th>
                                                            <th scope="col" class="">Curso</th>
                                                            <th scope="col" class="">Descripción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="cursos.length" v-for="(client, index) in cursos"
                                                            :key="client.id"
                                                            class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                                            <td
                                                                class="whitespace-nowrap border-none font-medium border-r-0">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="whitespace-nowrap border-none">{{ client.label }} {{
                                                                client.nombres
                                                            }}</td>
                                                            <td class="whitespace-nowrap border-none">{{ client.description
                                                            }}</td>

                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- Calificaciones -->
                                <div
                                    class="bg-white tab tab-green w-full overflow-hidden border border-green-200 mb-6 rounded-lg">
                                    <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-two"
                                        type="radio" name="tabs2">
                                    <label class="block p-5 leading-normal cursor-pointer bg-green-100 content-center"
                                        for="tab-single-two" style="height: 66px">
                                        <div class="my-auto inline-flex items-center" style="height: 24px">
                                            <span class="inline-flex font-semibold text-green-600">
                                                <BaseIcon :path="mdiCheckDecagram" :size="24" class="mr-3 " />
                                                Calificaciones
                                            </span>
                                        </div>

                                    </label>
                                    <div
                                        class="tab-content overflow-hidden border-l-2 border-green-600  bg-white leading-normal">
                                        <div class="flex flex-wrap tab-m mt-2 ml-1">
                                            <button
                                                @click="(tabCalif = 0), listarCalification((anioSearch ?? confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B1')"
                                                class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                                                :class="[tabCalif == 0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                                                <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Primer
                                                    bimestre</span>
                                            </button>
                                            <button
                                                @click="(tabCalif = 1), listarCalification((anioSearch ?? confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B2')"
                                                class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                                                :class="[tabCalif == 1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                                                <span
                                                    class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Segundo
                                                    bimestre</span>
                                            </button>
                                            <button
                                                @click="(tabCalif = 2), listarCalification((anioSearch ?? confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B3')"
                                                class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                                                :class="[tabCalif == 2 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                                                <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Tercer
                                                    bimestre</span>
                                            </button>

                                            <button
                                                @click="(tabCalif = 3), listarCalification((anioSearch ?? confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B4')"
                                                class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                                                :class="[tabCalif == 3 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                                                <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Cuarto
                                                    bimestre</span>
                                            </button>
                                        </div>

                                        <!-- Primer Bimestre -->
                                        <div v-if="tabCalif == 0">
                                            <div v-if="arrayCalifications && !arrayCalifications.length">
                                                <div class="w-full flex justify-start mt-4 ml-4">
                                                    <template v-if="canWrite">
                                                        <div class="p-4">
                                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20"
                                                                small label="Iniciar calificaciones"
                                                                @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" />
                                                            <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar
                                                            las calificaciones todas se guardan inicialmente con 8.
                                                        </div>
                                                    </template>
                                                    <div v-else class="p-4">
                                                        <BaseIcon :path="mdiInformationOutline" size="15" /> No se han
                                                        iniciado calificaciones de este bimestre.
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="canWrite && arrayCalifications.length" class="p-4">
                                                    <div>
                                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                            label="Añadir calificaciones faltantes"
                                                            @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" />
                                                    </div>
                                                    <p class="p-4">
                                                        * Puede pasar a la siguiente fila de la misma columna presionando
                                                        TAB o ENTER, todos los campos deben contener un valor número para
                                                        que el promedio sea válido.
                                                    </p>
                                                </div>
                                                <table class="table-auto">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Curso</th>
                                                            <th class="text-center">{{  (trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')  }}</th>
                                                            <th class="text-center" title="Participación">Participación</th>
                                                            <th class="text-center" title="Tarea">Tarea</th>
                                                            <th class="text-center">{{ (trans['Conducta'] ? trans['Conducta'] : 'Conducta') }}</th>
                                                            <th class="text-center" title="Examen parcial">Ex. parcial</th>
                                                            <th v-if="confGlobal.value.EXAMEN_PARCIAL2_PRIMER_BIMESTRE == 1"
                                                                class="text-center" title="Examen parcial2">Ex. parcial2
                                                            </th>
                                                            <th class="text-center" title="Examen final">Ex. final</th>
                                                            <th class="text-center" title="Promedio">Promedio</th>
                                                            <th v-if="canWrite" class="text-center" title="Actions"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                                        <tr v-for="(cal, index) in arrayCalifications" :key="cal.id">
                                                            <td data-label="#">{{ index + 1 }}</td>
                                                            <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                                {{ cal.label_course }} - {{ cal.ref_level }}
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')">
                                                                <!-- {{ formatNotaOut(cal.asistencia) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.asistencia
                                                                }}</span>
                                                                <input v-else v-model="cal.asistencia"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.asistencia < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()"
                                                                    :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                            </td>
                                                            <td class="text-center" data-label="Participación">
                                                                <!-- {{ formatNotaOut(cal.participacion) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.participacion
                                                                }}</span>
                                                                <input v-else v-model="cal.participacion"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.participacion < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="200 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Tarea">
                                                                <!-- {{ formatNotaOut(cal.tarea) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.tarea }}</span>
                                                                <input v-else v-model="cal.tarea"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.tarea < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="300 + index">
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Conducta'] ? trans['Conducta'] : 'Conducta')">
                                                                <!-- {{ formatNotaOut(cal.conducta) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.conducta }}</span>
                                                                <input v-else v-model="cal.conducta"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.conducta < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="400 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen parcial">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.examen_parcial
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="500 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_PRIMER_BIMESTRE == 1"
                                                                class="text-center" data-label="Examen parcial2">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.examen_parcial2
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial2"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial2 < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="600 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen final">
                                                                <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.examen_final
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_final"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_final < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="700 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_PRIMER_BIMESTRE == 1"
                                                                class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_parcial2) + parseInt(cal.examen_final)) / 7).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-else class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_final)) / 6).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB1">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-if="canWrite && !closeB1" class="flex lg:table-cell"
                                                                colspan="6">
                                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                                    <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->

                                                                    <BaseButton name="buttonssaveB1" color="info"
                                                                        :icon="mdiContentSave" small
                                                                        @click="updateCalification(cal.id, 'actualizar', cal)" />

                                                                    <!-- <BaseButton
                                                                                v-if="cal.status"
                                                                                color="success"
                                                                                :icon="mdiCheckCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'borrador')"
                                                                                title="Publicado"
                                                                                />
                                                                                <BaseButton
                                                                                v-else
                                                                                color="contrast"
                                                                                :icon="mdiCloseCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'publicar')"
                                                                                title="Borrador"
                                                                                /> -->

                                                                </BaseButtons>

                                                            </td>
                                                            <td data-label="Log" @click="showLog = !showLog">
                                                                <BaseIcon :path="mdiInformationOutline"
                                                                    title="Modificado por" size="15" />
                                                                <span class="text-xs" v-if="showLog">Modif. {{
                                                                    cal.nombre_usuario }} {{ cal.updated_at ?
                                                                        formatDateTime(cal.updated_at) : '' }}</span>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="canWrite && !closeB1">
                                                            <td class="flex lg:table-cell" colspan="6">
                                                                <div class="w-full flex justify-end">
                                                                    <BaseButton :icon="mdiContentSave" color="info"
                                                                        label="Guardar todo" icon-size="20" small
                                                                        @click="updateArrayCalifications('B1')" />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- <p v-else class="p-5">
                                                            Aun no se inicia las calificaciones
                                                        </p> -->
                                        </div>

                                        <!-- Segundo Bimestre -->
                                        <div v-if="tabCalif == 1">
                                            <div v-if="arrayCalifications && !arrayCalifications.length">
                                                <div class="w-full flex justify-start mt-4 ml-4">
                                                    <template v-if="canWrite">
                                                        <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                                                        icon-size="20" small label="Refresh" @click="refreshList(['caficicationsb2'])"/> -->
                                                        <div class="p-4">
                                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20"
                                                                small label="Iniciar calificaciones"
                                                                @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" />
                                                            <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar
                                                            las calificaciones todas se guardan inicialmente con 8.
                                                        </div>
                                                    </template>
                                                    <div v-else class="p-4">
                                                        <BaseIcon :path="mdiInformationOutline" size="15" /> No se han
                                                        iniciado calificaciones de este bimestre.
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="canWrite && arrayCalifications.length" class="p-4">
                                                    <!--  != students.length -->
                                                    <div>
                                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                            label="Añadir calificaciones faltantes"
                                                            @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" />
                                                    </div>
                                                    <p class="p-4">
                                                        * Puede pasar a la siguiente fila de la misma columna presionando
                                                        TAB o ENTER, todos los campos deben contener un valor número para
                                                        que el promedio sea válido.
                                                    </p>
                                                </div>

                                                <table class="table-auto">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Curso</th>
                                                            <th class="text-center">{{  (trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')  }}</th>
                                                            <th class="text-center" title="Participación">Part.</th>
                                                            <th class="text-center" title="Tarea">Tarea</th>
                                                            <th class="text-center">{{ (trans['Conducta'] ? trans['Conducta'] : 'Conducta') }}</th>
                                                            <th class="text-center" title="Examen parcial">Ex. parcial</th>
                                                            <th v-if="confGlobal.value.EXAMEN_PARCIAL2_SEGUNDO_BIMESTRE == 1"
                                                                class="text-center" title="Examen parcial2">Ex. parcial2
                                                            </th>
                                                            <th class="text-center" title="Examen final">Ex. final</th>
                                                            <th class="text-center" title="Promedio">Promedio</th>
                                                            <th v-if="canWrite" class="text-center" title="Actions"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                                        <tr v-for="(cal, index) in arrayCalifications" :key="cal.id">
                                                            <td data-label="#">{{ index + 1 }}</td>
                                                            <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                                {{ cal.label_course }} - {{ cal.ref_level }}
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')">
                                                                <!-- {{ formatNotaOut(cal.asistencia) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.asistencia
                                                                }}</span>
                                                                <input v-else v-model="cal.asistencia"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.asistencia < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()"
                                                                    :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                            </td>
                                                            <td class="text-center" data-label="Participación">
                                                                <!-- {{ formatNotaOut(cal.participacion) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.participacion
                                                                }}</span>
                                                                <input v-else v-model="cal.participacion"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.participacion < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="200 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Tarea">
                                                                <!-- {{ formatNotaOut(cal.tarea) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.tarea }}</span>
                                                                <input v-else v-model="cal.tarea"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.tarea < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="300 + index">
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Conducta'] ? trans['Conducta'] : 'Conducta')">
                                                                <!-- {{ formatNotaOut(cal.conducta) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.conducta }}</span>
                                                                <input v-else v-model="cal.conducta"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.conducta < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="400 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen parcial">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.examen_parcial
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="500 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_SEGUNDO_BIMESTRE == 1"
                                                                class="text-center" data-label="Examen parcial2">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.examen_parcial2
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial2"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial2 < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="600 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen final">
                                                                <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.examen_final
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_final"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_final < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="700 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_SEGUNDO_BIMESTRE == 1"
                                                                class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_parcial2) + parseInt(cal.examen_final)) / 7).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-else class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_final)) / 6).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB2">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-if="canWrite && !closeB2" class="flex lg:table-cell"
                                                                colspan="6">
                                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                                    <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->

                                                                    <BaseButton name="buttonssaveB2" color="info"
                                                                        :icon="mdiContentSave" small
                                                                        @click="updateCalification(cal.id, 'actualizar', cal)" />

                                                                    <!-- <BaseButton
                                                                                v-if="cal.status"
                                                                                color="success"
                                                                                :icon="mdiCheckCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'borrador')"
                                                                                title="Publicado"
                                                                                />
                                                                                <BaseButton
                                                                                v-else
                                                                                color="contrast"
                                                                                :icon="mdiCloseCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'publicar')"
                                                                                title="Borrador"
                                                                                /> -->

                                                                </BaseButtons>

                                                            </td>
                                                            <td data-label="Log" @click="showLog = !showLog">
                                                                <BaseIcon :path="mdiInformationOutline"
                                                                    title="Modificado por" size="15" />
                                                                <span class="text-xs" v-if="showLog">Modif. {{
                                                                    cal.nombre_usuario }} {{ cal.updated_at ?
        formatDateTime(cal.updated_at) : '' }}</span>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="canWrite && !closeB2">
                                                            <td class="flex lg:table-cell" colspan="6">
                                                                <div class="w-full flex justify-end">
                                                                    <BaseButton :icon="mdiContentSave" color="info"
                                                                        label="Guardar todo" icon-size="20" small
                                                                        @click="updateArrayCalifications('B2')" />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- <p v-else class="p-5">
                                                            Aun no se inicia las calificaciones
                                                        </p> -->
                                        </div>

                                        <!-- Tercer Bimestre -->
                                        <div v-if="tabCalif == 2">
                                            <div v-if="arrayCalifications && !arrayCalifications.length">
                                                <div class="w-full flex justify-start mt-4 ml-4">
                                                    <template v-if="canWrite">

                                                        <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                                                        icon-size="20" small label="Refresh" @click="refreshList(['caficicationsb2'])"/> -->
                                                        <div class="p-4">
                                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20"
                                                                small label="Iniciar calificaciones"
                                                                @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" />
                                                            <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar
                                                            las calificaciones todas se guardan inicialmente con 8.
                                                        </div>
                                                    </template>
                                                    <div v-else class="p-4">
                                                        <BaseIcon :path="mdiInformationOutline" size="15" /> No se han
                                                        iniciado calificaciones de este bimestre.
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="canWrite && arrayCalifications.length" class="p-4">
                                                    <div>
                                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                            label="Añadir calificaciones faltantes"
                                                            @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" />
                                                    </div>
                                                    <p class="p-4">
                                                        * Puede pasar a la siguiente fila de la misma columna presionando
                                                        TAB o ENTER, todos los campos deben contener un valor número para
                                                        que el promedio sea válido.
                                                    </p>
                                                </div>
                                                <table class="table-auto">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Curso</th>
                                                            <th class="text-center">{{  (trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')  }}</th>
                                                            <th class="text-center" title="Participación">Part.</th>
                                                            <th class="text-center" title="Tarea">Tarea</th>
                                                            <th class="text-center">{{ (trans['Conducta'] ? trans['Conducta'] : 'Conducta') }}</th>
                                                            <th class="text-center" title="Examen parcial">Ex. parcial</th>
                                                            <th v-if="confGlobal.value.EXAMEN_PARCIAL2_TERCER_BIMESTRE == 1"
                                                                class="text-center" title="Examen parcial2">Ex. parcial2
                                                            </th>
                                                            <th class="text-center" title="Examen final">Ex. final</th>
                                                            <th class="text-center" title="Promedio">Promedio</th>
                                                            <th v-if="canWrite" class="text-center" title="Actions"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                                        <tr v-for="(cal, index) in arrayCalifications" :key="cal.id">
                                                            <td data-label="#">{{ index + 1 }}</td>
                                                            <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                                {{ cal.label_course }} - {{ cal.ref_level }}
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')">
                                                                <!-- {{ formatNotaOut(cal.asistencia) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.asistencia
                                                                }}</span>
                                                                <input v-else v-model="cal.asistencia"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.asistencia < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()"
                                                                    :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                            </td>
                                                            <td class="text-center" data-label="Participación">
                                                                <!-- {{ formatNotaOut(cal.participacion) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.participacion
                                                                }}</span>
                                                                <input v-else v-model="cal.participacion"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.participacion < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="200 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Tarea">
                                                                <!-- {{ formatNotaOut(cal.tarea) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.tarea }}</span>
                                                                <input v-else v-model="cal.tarea"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.tarea < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="300 + index">
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Conducta'] ? trans['Conducta'] : 'Conducta')">
                                                                <!-- {{ formatNotaOut(cal.conducta) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.conducta }}</span>
                                                                <input v-else v-model="cal.conducta"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.conducta < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="400 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen parcial">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.examen_parcial
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="500 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_TERCER_BIMESTRE == 1"
                                                                class="text-center" data-label="Examen parcial2">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.examen_parcial2
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial2"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial2 < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="600 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen final">
                                                                <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.examen_final
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_final"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_final < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="700 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_TERCER_BIMESTRE == 1"
                                                                class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_parcial2) + parseInt(cal.examen_final)) / 7).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-else class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_final)) / 6).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB3">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-if="canWrite && !closeB3" class="flex lg:table-cell"
                                                                colspan="6">
                                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                                    <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->

                                                                    <BaseButton name="buttonssaveB3" color="info"
                                                                        :icon="mdiContentSave" small
                                                                        @click="updateCalification(cal.id, 'actualizar', cal)" />

                                                                    <!-- <BaseButton
                                                                                v-if="cal.status"
                                                                                color="success"
                                                                                :icon="mdiCheckCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'borrador')"
                                                                                title="Publicado"
                                                                                />
                                                                                <BaseButton
                                                                                v-else
                                                                                color="contrast"
                                                                                :icon="mdiCloseCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'publicar')"
                                                                                title="Borrador"
                                                                                /> -->

                                                                </BaseButtons>

                                                            </td>
                                                            <td data-label="Log" @click="showLog = !showLog">
                                                                <BaseIcon :path="mdiInformationOutline"
                                                                    title="Modificado por" size="15" />
                                                                <span class="text-xs" v-if="showLog">Modif. {{
                                                                    cal.nombre_usuario }} {{ cal.updated_at ?
        formatDateTime(cal.updated_at) : '' }}</span>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="canWrite && !closeB3">
                                                            <td class="flex lg:table-cell" colspan="6">
                                                                <div class="w-full flex justify-end">
                                                                    <BaseButton :icon="mdiContentSave" color="info"
                                                                        label="Guardar todo" icon-size="20" small
                                                                        @click="updateArrayCalifications('B3')" />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- <p v-else class="p-5">
                                                            Aun no se inicia las calificaciones del tercer bimestre
                                                        </p> -->
                                        </div>

                                        <!-- Cuarto bimestre -->
                                        <div v-if="tabCalif == 3">
                                            <div v-if="arrayCalifications && !arrayCalifications.length">
                                                <div class="w-full flex justify-start mt-4 ml-4">
                                                    <template v-if="canWrite">
                                                        <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                                                        icon-size="20" small label="Refresh" @click="refreshList(['caficicationsb2'])"/> -->
                                                        <div class="p-4">
                                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20"
                                                                small label="Iniciar calificaciones"
                                                                @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" />
                                                            <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar
                                                            las calificaciones todas se guardan inicialmente con 8.
                                                        </div>
                                                    </template>
                                                    <div v-else class="p-4">
                                                        <BaseIcon :path="mdiInformationOutline" size="15" /> No se han
                                                        iniciado calificaciones de este bimestre.
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="canWrite && arrayCalifications.length" class="p-4">
                                                    <div>
                                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                            label="Añadir calificaciones faltantes"
                                                            @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" />
                                                    </div>
                                                    <p class="p-4">
                                                        * Puede pasar a la siguiente fila de la misma columna presionando
                                                        TAB o ENTER, todos los campos deben contener un valor número para
                                                        que el promedio sea válido.
                                                    </p>
                                                </div>

                                                <table class="table-auto">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Curso</th>
                                                            <th class="text-center">{{  (trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')  }}</th>
                                                            <th class="text-center" title="Participación">Part.</th>
                                                            <th class="text-center" title="Tarea">Tarea</th>
                                                            <th class="text-center">{{ (trans['Conducta'] ? trans['Conducta'] : 'Conducta') }}</th>
                                                            <th class="text-center" title="Examen parcial">Ex. parcial</th>
                                                            <th v-if="confGlobal.value.EXAMEN_PARCIAL2_CUARTO_BIMESTRE == 1"
                                                                class="text-center" title="Examen parcial2">Ex. parcial2
                                                            </th>
                                                            <th class="text-center" title="Examen final">Ex. final</th>
                                                            <th class="text-center" title="Promedio">Promedio</th>
                                                            <th v-if="canWrite" class="text-center" title="Actions"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                                        <tr v-for="(cal, index) in arrayCalifications" :key="cal.id">
                                                            <td data-label="#">{{ index + 1 }}</td>
                                                            <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                                {{ cal.label_course }} - {{ cal.ref_level }}
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Asistencia'] ? trans['Asistencia'] : 'Asistencia')">
                                                                <!-- {{ formatNotaOut(cal.asistencia) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.asistencia
                                                                }}</span>
                                                                <input v-else v-model="cal.asistencia"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.asistencia < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()"
                                                                    :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                            </td>
                                                            <td class="text-center" data-label="Participación">
                                                                <!-- {{ formatNotaOut(cal.participacion) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.participacion
                                                                }}</span>
                                                                <input v-else v-model="cal.participacion"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.participacion < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="200 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Tarea">
                                                                <!-- {{ formatNotaOut(cal.tarea) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.tarea }}</span>
                                                                <input v-else v-model="cal.tarea"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.tarea < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="300 + index">
                                                            </td>
                                                            <td class="text-center" :data-label="(trans['Conducta'] ? trans['Conducta'] : 'Conducta')">
                                                                <!-- {{ formatNotaOut(cal.conducta) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.conducta }}</span>
                                                                <input v-else v-model="cal.conducta"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.conducta < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="400 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen parcial">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.examen_parcial
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="500 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_CUARTO_BIMESTRE == 1"
                                                                class="text-center" data-label="Examen parcial2">
                                                                <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.examen_parcial2
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_parcial2"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_parcial2 < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="600 + index">
                                                            </td>
                                                            <td class="text-center" data-label="Examen final">
                                                                <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.examen_final
                                                                }}</span>
                                                                <input v-else v-model="cal.examen_final"
                                                                    class="inline-block w-full focusNext"
                                                                    :class="(cal.examen_final < 11 ? 'text-red-600' : '')"
                                                                    @focus="$event.target.select()" :tabindex="700 + index">
                                                            </td>
                                                            <td v-if="confGlobal.value.EXAMEN_PARCIAL2_CUARTO_BIMESTRE == 1"
                                                                class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_parcial2) + parseInt(cal.examen_final)) / 7).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-else class="text-center"
                                                                :class="(cal.promedio < 11 ? 'text-red-600' : '')"
                                                                data-label="Promedio"
                                                                :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((parseInt(cal.asistencia) + parseInt(cal.participacion) + parseInt(cal.tarea) + parseInt(cal.conducta) + parseInt(cal.examen_parcial) + parseInt(cal.examen_final)) / 6).toFixed(2)))"
                                                                :title="promedio_decimal + ' = ' + cal.promedio_text">
                                                                <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                                <span v-if="!canWrite || closeB4">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio"
                                                                    class="inline-block w-full">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </td>
                                                            <td v-if="canWrite && !closeB4" class="flex lg:table-cell"
                                                                colspan="6">
                                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                                    <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->

                                                                    <BaseButton name="buttonssaveB4" color="info"
                                                                        :icon="mdiContentSave" small
                                                                        @click="updateCalification(cal.id, 'actualizar', cal)" />

                                                                    <!-- <BaseButton
                                                                                v-if="cal.status"
                                                                                color="success"
                                                                                :icon="mdiCheckCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'borrador')"
                                                                                title="Publicado"
                                                                                />
                                                                                <BaseButton
                                                                                v-else
                                                                                color="contrast"
                                                                                :icon="mdiCloseCircle"
                                                                                small
                                                                                @click="updateCalification(cal.id, 'publicar')"
                                                                                title="Borrador"
                                                                                /> -->

                                                                </BaseButtons>

                                                            </td>
                                                            <td data-label="Log" @click="showLog = !showLog">
                                                                <BaseIcon :path="mdiInformationOutline"
                                                                    title="Modificado por" size="15" />
                                                                <span class="text-xs" v-if="showLog">Modif. {{
                                                                    cal.nombre_usuario }} {{ cal.updated_at ?
        formatDateTime(cal.updated_at) : '' }}</span>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="canWrite && !closeB4">
                                                            <td class="flex lg:table-cell" colspan="6">
                                                                <div class="w-full flex justify-end">
                                                                    <BaseButton :icon="mdiContentSave" color="info"
                                                                        label="Guardar todo" icon-size="20" small
                                                                        @click="updateArrayCalifications('B4')" />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- <p v-else class="p-5">
                                                            Aun no se inicia las calificaciones del cuarto bimestre
                                                        </p> -->
                                        </div>

                                        <div class="p-4" v-if="tabCalif == -1">
                                            Click al bimestre para mostrar el listado ⤴
                                        </div>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </template>
                <!-- Agenda -->
                <template v-else-if="(tab == 3)">
                    <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">

                        <!-- <div class="container">
                                        <VueCal
                                        :time="false"
                                        locale="es"
                                        :disable-views="['years', 'year']"
                                        :events="events"
                                        class="vuecal--green-theme"
                                        active-view="month"
                                        hide-weekends 
                                        />
                                    </div> -->

                        <!-- Registro Diario -->
                        <li>(A): Asistencia</li>
                        <li>(F): Falta</li>
                        <li>(T): Tardanza</li>

                        <!-- Documentación: https://antoniandre.github.io/vue-cal/?ref=madewithvuejs.com -->
                        <!-- Ejemplo: https://codepen.io/antoniandre/pen/jJbygw?editors=1010 -->
                        <!-- If the container has no height, set a height on vue-cal -->
                        <!-- vuecal--green-theme o vuecal--blue-theme -->
                        <!-- active-view="month" por defecto se ve por semana en la confiuración anterior -->

                        <!-- https://antoniandre.github.io/vue-cal/#ex--calendar-themes -->
                        <!-- vuecal--rounded-theme -->
                        <!-- hide-view-selector  es para ocultar la sección de la vista tipo mes o semana-->
                        <!-- xsmall  lo establece en formato pequeño y el nombre de días lo pone en abreviado-->

                        <!-- Otros estilos -->
                        <!-- https://antoniandre.github.io/vue-cal/#css-notes -->

                        <!-- <div class="block h-full w-full">
                                        <VueCal
                                        xsmall
                                        :time="false"
                                        locale="es"
                                        hide-view-selector
                                        :disable-views="['years', 'year']"
                                        :events="events"
                                        class="vuecal--date-picker vuecal--green-theme"
                                        active-view="week"
                                        hide-weekends
                                        
                                        />
                                    </div> -->

                        <div class="block h-full w-full">
                            <VueCal :transitions="false" small :time="false" locale="es" hide-view-selector
                                :disable-views="['years', 'year', 'day', 'month']" :events="events" class="cal-rose"
                                active-view="week" hide-weekends />
                            <!-- xsmall abreviatura de los títulos de días L, M, M -->
                            <!-- :on-event-click="onEventClick" -->
                        </div>


                    </div>
                </template>
                <!-- Informe Histórico -->
                <template v-else-if="(tab == 4)">
                    <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                        
                        <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Informe histórico: {{ object.person.apellidos + ' ' +
                            object.person.nombres }}</h5>
                        <div class="block h-full w-full">
                            <CardBox v-if="stories.length" class="mb-6" has-table>
                                <div class="mt-6">
                                
                                    <table class="min-w-full text-sm font-light table-responsive-wfull">
                                        <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                            <tr>
                                                <th scope="col" class="">#</th>
                                                <th scope="col" class="">Año</th>
                                                <th scope="col" class="">Nivel</th>
                                                <th scope="col" class="">Fecha Matrícula</th>
                                                <th scope="col" class="">Tipo</th>
                                                <th scope="col" class="">Aula de estudio</th>
                                                <th scope="col" class="">Aula de matrícula</th>
                                                <th scope="col" class="">Aula Ugel</th>
                                                <th scope="col" class="">Exonerado Religión</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="stories.length" v-for="(client, index) in stories"
                                                :key="client.id"
                                                class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                                <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                                </td>
                                                <td class="whitespace-nowrap border-none">{{ client.anio }}</td>
                                                <td class="whitespace-nowrap border-none">{{ client.label_level }}</td>
                                                <td class="whitespace-nowrap border-none"> {{ client.fecha_matricula }} </td>
                                                <td class="whitespace-nowrap border-none"> {{ client.type ? 'Antiguo' : 'Nuevo' }} </td>
                                                <td class="whitespace-nowrap border-none"> {{ client.label_classroom }} </td>
                                                <td class="whitespace-nowrap border-none"> {{ client.label_classroom_matricula }} </td>
                                                <td class="whitespace-nowrap border-none"> {{ client.ref_classroom_ugel + ' ' + client.label_classroom_ugel }} </td>
                                                <td class="whitespace-nowrap border-none"> {{ client.exonerado_religion ? 'Si' : 'No' }} </td>
                                            </tr>
                                            <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                                <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                        registros …</span></td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                
                            </CardBox>
                            
                        </div>


                    </div>
                </template>
                <!-- Documentos -->
                <template v-else-if="(tab == 5)">
                    <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                        Documentos adjuntos de {{ object.person.apellidos + ' ' +
                            object.person.nombres }}
                        
                        <!-- <div v-if="message">{{ message }}</div> -->

                        <div v-if="canWrite" class="mb-3">
                            <small class="my-2">
                                Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                                PNG, con un <b>límite máximo</b> de {{
                                    confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                            </small>
                            <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))"
                                class="mb-4">
                                <small class="font-medium text-red-600">El archivo
                                    supera
                                    el tamaño límite permitido</small>
                            </div>
                            <div class="mt-3">
                                <BreezeLabel for="name" value="Nombre de Archivo"
                                    required />
                                <BreezeInput id="inputname" type="text"
                                    class="mt-1 block" v-model="inputFileName"
                                    required />
                            </div>
                            <div>
                                <BreezeLabel for="desc" value="Descricpión (opcional)" />
                                <BreezeInput id="inputdesc" type="text"
                                    class="mt-1 block w-full"
                                    v-model="inputFileDesc" autocomplete="off"/>
                            </div>
                            <!-- <div>
                                <BreezeLabel for="pos" value="Posición" />
                                <BreezeInput id="inputpos" type="number"
                                    class="mt-1 block" v-model="inputFilePos" />
                            </div> -->
                            <input id="file_document_student" ref="fileDocument"
                                type="file"
                                @change="changeFile('file_document_student')"
                                class="mt-4"
                                accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">

                            <BaseButton :icon="mdiPlusCircle" color="info"
                                class="ml-2 mt-4" icon-size="20" small
                                label="Guardar"
                                @click="uploadFile('file_document_student')" />
                        </div>
                        <hr>
                        <!-- Lista -->
                        <div class="block h-full w-full mt-3">
                            <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file"
                                    :deleteable="canDelete ? true : false"
                                    originType="file_document_student" :originId="object.id"
                                    @reload="listarDocumentos()"
                                    checkable
                                />
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>


                    </div>
                </template>
            </div>
        </div>


    </BreezeAuthenticatedLayout>
</template>
